import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import {
  InitializeReduxStore,
  SaveEvents,
  UpdatedWipAndActuals,
  RestoreToBeRectifiedCountsAndThenReleaseLock,
  ToBeRectifiedSaveEvents,
  AcquireUserDBLockAndAddBulkEvents,
  UpdateLockDetails,
  AcquireLockAndNotifyBctxChangeAndDismissModalAndReleaseLock,
  AcquireLockAndClearSelectedBctxAndReleaseLock,
  AcquireLockAndThenRestoreActuals,
  AcquireUserDBLockAndSyncStyleInfo,
  AcquireBgDBLockAndThenSyncEvents,
  AcquireLockAndRestoreToBeRectifiedCounts,
  BackUpBctxData,
  AcquireUserDBLockAndThenRestoreActualsForBackedUpBctx,
  AddBctxChangeEventForOnlineApps,
  AcquireLockAndThenInitializeUserAndBgDBs,
  UpdateBgDBLockDetails,
  AcquireUserDBLockAndBgDBLockAndReconcile,
  UpdateBgDB,
  AcquireUserDBLockAndClearToBeRectifiedList,
  AcquireUserDBLockAndLoadToBeRectifiedData,
  AcquireUserDBLockAndValidateUndoBulkEventAndAddEvents,
  ClearAndReFetchPerPieceLineInTransactions,
  ClearPerPieceLineInTransactions,
  UpdatePerPieceQcCurrentActionInfo,
  AcquireUserDBLockAndFetchIncompleteBundles,
  AcquireUserDBLockAndUpdateIncompleteBundlesInfo,
  AcquireUserBgDBLockAndCheckEventsValidAndThenAddBulkEvents,
  AcquireLockAndFetchNewBctxSizeList,
  AcquireLockAndUpdateBctxWithoutChangeEvent,
  AcquireUserDBLockAndSyncStyleInfoForPlanBased,
  AcquireUserDBLockAndPopulateLineMapForPlanBased,
  AcquireLockAndUpdateFilteredSizesListInLineMap,
  AcquireUserDBLockAndHandleSideActions,
  reSyncTodayFailedEventsAndThenReleaseUserAndBgDBLock,
  reSyncPastDaysFailedEventsAndThenReleaseBgDBLock,
  CaptureSnapShotOfDbs,
} from './input-app-client-db.action';
import {
  getActionTypeToTotalActualsMap,
  getBusinessContextDataPayload,
  getRestoreApiPayload,
  getSizeList,
  getselectedBctxInfo,
  getStationDetails,
  getToBeRectifiedListing,
  getRectifiedBCTXKeysInfo,
  getAppEventsApiPayloadWithoutDateTimeAndRecords,
  getWhoObjectOfEventPayloadWithoutUserInfo,
  getBctxItemAndSizeList,
  getStationDetailsAndSelectedBctxItem,
  getSelectedStationIdAndShiftId,
  getBusinessContextListing,
  getBctxWipMap,
  getSelectedStationAndShiftDTO,
  getEventsArray,
  getPendingEvents,
  getLastFttEventForCurrentLineAndShift,
  getRecentDefects,
  getselectedBctxItemAndOrderKeysAndBctxDisplayMap,
  getMemberAdditionList,
  getUserDBLockDetailsAndNextCacheResetTime,
  selectInputAppDB,
  getMergedLineMapAndSelectedStationIdAndShiftId,
  getClientDBAndOnlineStatusAndEventsBatchCountAndCurrentLineAndShift,
  getBackUpAPIPayload as getBackUpAPIPayloadWithoutBctxInfo,
  getLineAndShiftRestorePayload,
  getAllBctxItemsAcrossAllLinesAndMasterdataListConfig,
  getBgDBLockDetailsAndNextCacheResetTime,
  getUserDBAndBgDBLockDetails,
  getActivityLogEvents,
  getPastDayYetToBeSyncedEvents,
  getBctxWipMapWithOrderKeys,
  getPositiveWipBusinessContextListing,
  getPerPieceLineInTransactionsPayloadMetadata,
  getPerPieceLineInTransactions,
  getAllBctxActualsMap,
  getCurrentLineActionInfo,
  getLastForwardBulkEventBeforeUndoEvent,
  getLastBulkCountEvent,
  getRecentDefectsV2,
  getDefectiveMetadata,
  getMemberAdditionViewDescriptorAndAddedList,
  getIncompleteBundlesInfoForCurrentStationAndShift,
  getAllLinesIncompleteBundlesInfo,
  hasIncompleteBundlesInfoInitializedForCurrentStationAndShift,
  getLogoutAckMetadata,
  getSubjectKeyAndSelectedSubject,
  getClientDBAndBgDB,
  getUserDBNextCacheResetTimestamp,
  getPlanBasedLineMap,
  getLineMap,
  getAllBctxItemsAcrossSelectedStaionId,
  getTodayAndPastDaysMergedEvents,
  getFilteredSizesListForSelectedBctx,
  getAllBctxActualsMapPerPiece,
  getStore,
  getReworkedEventsList,
  getBulkMdPointEvents,
} from './input-app-client-db.query';
import {
  TREQUEST_ToBeRectifiedListing,
  TREQUEST_RestoreToBeRectifiedCounts,
  TToBeRectifiedDTO,
  TToBeRectifiedSaveEventActionType,
  TSelectedStationIdAndShiftId,
  TSyncEventsDTO,
  TREQUEST_AppEventsRequestDTO,
  TBulkEvent,
  TUserDBLockedBy,
  TUserDBLockResult,
  TEventBctxDetails,
  TEventLocation,
  TEventStationDetails,
  TForwardBulkEvent,
  TSyncEventStatus,
  TBctxWithMultipleSize,
  TBctxItemWithoutSize,
  TBctxItemWithoutSizeAndBctxKey,
  TForwardEventActionType,
  TUndoDTO,
  TBCTXChangeEventType,
  TMDPointGradingPageAction,
  TBackUpDataStatusDB,
  UNDO_ERROR_TO_DISPLAY_MESSAGE,
  TBgDBLockedBy,
  TBgDBLockResult,
  TCommonLockedBy,
  TBctxChangeEventWithoutStatus,
  TBulkEventWithoutStatus,
  TUserAction,
  TUserActualsDB,
  TBackgroundEventsSyncingDB,
  TMemberAdditionInfo,
  TAuditDTOModel,
  TRoamingQcEventWithoutStatus,
  TEventAddtionSideActions,
  TLoadBctxSideActions,
  TLineChangeActions,
  TBctxItem,
  TSingleCountEvent,
  TBulkCountEvent,
  TLastEventDetails,
  TBCTXKeys,
  IQCLanding,
  TClientDBInitInfo,
  TRestoreBackedUpBctx,
  TEventAddtionMoreActions,
  TBctxChangeEventSizeInfo,
  TPerPieceLineInUndoDTO,
  TSelectedBctxInfo,
  TLoadBctxMoreActions,
  TPerPieceDefectOrRejectAdditionDTO,
  TPerPieceQcUntoDTO,
  TShowExistingPerPieceDefectiveDTO,
  TPerPieceQcCurrentActionInfo,
  TIncompleteBundlesInfo,
  BctxViz,
  TRemoteDeploymentCheck,
  TRemoteDeploymentCheckWithEventsSyncResult,
  TSingleAuditDetail,
  TAqlEventWithoutStatus,
  TToBeSyncedEventsDTO,
  TAppIdentifier,
  TREQUEST_BctxGroupedDetails,
  TNewBctxItemInPOSplit,
  TLoadBctxSideActionsPlanBased,
  TMasterDataListMetaData,
  TEventCommonDetails,
  TBCTXKeysWithDateTime,
  TPastDaySyncedEventsDB,
  TActivityLogEvent,
  TReSyncEventsDayType,
  TMemberAdditionSingleEvent,
} from '@monorepo/types';
import { TUserPaginationOption } from '@monorepo/ui';
import { combineLatest, from, Observable, of, Subject } from 'rxjs';
import { catchError, map, switchMap, take } from 'rxjs/operators';
import {
  AuthService,
  getBctxItemsOrderWithoutSize,
  getBctxKeysToDisplayMap,
  getBctxViz,
  getBctxVizAndBctxItemsOrderWithoutSize,
  getBuzKeys,
  getConfigurations,
  getInputAppInitialState,
  getMemberAdditionViewDescriptor,
  getQCLandingViewDescriptor,
  getSimpleGradingPageViewDescriptor,
  getSubjectKey,
  getTransactionWipTypeAndSubjectKeyAndAppIdentifier,
  getUndoValidateInfo,
  PersistentStorageService,
  getAppIdentifier,
  DEFAULT_LINE_SHIFT_INCOMPLETE_BUNDLE_INFO,
  getWashingLandingViewDescriptor,
  getBctxItemsOrderForBackUp,
  getSimpleLineInGradingPageViewDescriptor,
} from '@monorepo/core-data';
import {
  BCTXComputationHelper,
  EventUtil,
  InputAppErrorDisplay,
  PerPieceComputationHelper,
  StackUtil,
} from '@monorepo/utils';
import {
  CustomLoggerService,
  HttpResponseException,
  InputAppDataService,
  ScannerDataFormatter,
  TechpackUploadDataProvider,
  TechpackUploadEnvProvider,
  UploadDownLoadFileService,
} from '@monorepo/services';
import { TInputAppState } from '../reducer';
import produce from 'immer';
import * as _ from 'lodash';
import { AlertController, Platform } from '@ionic/angular';
import * as moment from 'moment';
import { getNextCacheResetTimestamp } from '../init-db/init-db.query';
import { TextToSpeech } from '@capacitor-community/text-to-speech';
import { TranslateService } from '@ngx-translate/core';
import { cloneDeep } from 'lodash';

@Injectable({
  providedIn: 'root',
})
export class InputAppClientDBFacade {
  private appUpdateSubscription = new Subject<TRemoteDeploymentCheckWithEventsSyncResult>();
  private syncIncompleteBundlesSubscription = new Subject<void>();
  private logoutAppSubscription = new Subject<void>();
  private loadAllMasterdataListsSubscription = new Subject<TMasterDataListMetaData>();
  private loadServerDefectivesSubscription = new Subject<boolean>();
  private showRoamingQcSuccessAndSyncEventsForWebSubscription = new Subject<{
    event: TRoamingQcEventWithoutStatus;
    toBeDismissedModalsCount: number;
  }>();
  private perPieceDefectOrRejectAdditionSubscription = new Subject<TPerPieceDefectOrRejectAdditionDTO>();
  private initUserDBAndBgDBSubscription = new Subject<TClientDBInitInfo>();
  private perPieceUndoTransactionSubscription = new Subject<void>();
  private showPerPieceDefectiveSubscription = new Subject<TShowExistingPerPieceDefectiveDTO>();
  private lockAction = false;
  private updateRFIDScannerDataProcessingState = new Subject<boolean>();
  private triggerBctxChangeEvent = new Subject<boolean>();
  private triggerStationChangeEvent = new Subject<void>();
  constructor(
    private store: Store<TInputAppState>,
    private authService: AuthService,
    private persistanceStorageService: PersistentStorageService,
    private inputAppDataService: InputAppDataService,
    private inputAppErrorDisplayUtil: InputAppErrorDisplay,
    private alertCtrl: AlertController,
    private platform: Platform,
    private translate: TranslateService,
    private scannerDataFormatter: ScannerDataFormatter,
    private techpackUploadDataProvider: TechpackUploadDataProvider,
    private techpackUploadEnvProvider: TechpackUploadEnvProvider,
    private uploadDownloadFileService: UploadDownLoadFileService,
    private customLoggerService: CustomLoggerService,
  ) {}

  backUpData() {
    this.store.dispatch(new BackUpBctxData());
  }

  getBackUpPayloadWithoutBctxInfo() {
    return this.store.pipe(select(getBackUpAPIPayloadWithoutBctxInfo));
  }

  InitializeClientDB() {
    this.store.dispatch(new AcquireLockAndThenInitializeUserAndBgDBs());
  }

  getAppUpdateSubscription() {
    return this.appUpdateSubscription.asObservable();
  }

  emitAppUpdateSubscription(remoteDeploymentCheckWithSyncResult: TRemoteDeploymentCheckWithEventsSyncResult) {
    this.appUpdateSubscription.next(remoteDeploymentCheckWithSyncResult);
  }

  getRFIDDataProcessingSubscription() {
    return this.updateRFIDScannerDataProcessingState.asObservable();
  }

  emitRFIDDataProcessingSubscription(isProcessing: boolean) {
    this.updateRFIDScannerDataProcessingState.next(isProcessing);
  }

  getLogoutAppSubscription() {
    return this.logoutAppSubscription.asObservable();
  }

  emitLogoutAppSubscription() {
    this.logoutAppSubscription.next();
  }

  getInitUserDBAndBgDBSubscription() {
    return this.initUserDBAndBgDBSubscription.asObservable();
  }

  emitSyncIncompleteBundlesSubscription() {
    this.syncIncompleteBundlesSubscription.next();
  }

  getSyncIncompleteBundlesSubscription() {
    return this.syncIncompleteBundlesSubscription.asObservable();
  }

  emitInitUserDBAndBgDBSubscription(dto: TClientDBInitInfo) {
    this.initUserDBAndBgDBSubscription.next(dto);
  }

  getLoadAllMasterdataListsSubscription() {
    return this.loadAllMasterdataListsSubscription.asObservable();
  }

  emitLoadAllMasterdataLists(masterDataListMetaData: TMasterDataListMetaData = { source: 'UNKNOWN' }) {
    this.loadAllMasterdataListsSubscription.next(masterDataListMetaData);
  }

  getPerPieceUndoTransactionSubscription() {
    return this.perPieceUndoTransactionSubscription.asObservable();
  }

  emitPerPieceUndoTransactionSubscription() {
    this.perPieceUndoTransactionSubscription.next();
  }

  getLoadServerDefectivesSubscription() {
    return this.loadServerDefectivesSubscription.asObservable();
  }

  emitLoadServerDefectivesSubscription(loadWithoutLoader: boolean) {
    this.loadServerDefectivesSubscription.next(loadWithoutLoader);
  }

  getShowRoamingQcSuccessAndSyncEventsForWebSubscription() {
    return this.showRoamingQcSuccessAndSyncEventsForWebSubscription.asObservable();
  }

  async speakOut(message: string) {
    await TextToSpeech.speak({
      text: message,
      lang: 'en-US',
      rate: 1.0,
      pitch: 1.0,
      volume: 1.0,
      category: 'ambient',
    });
  }

  emitShowRoamingQcSuccessAndSyncEventsForWebSubscription(
    event: TRoamingQcEventWithoutStatus,
    toBeDismissedModalsCount: number,
  ) {
    this.showRoamingQcSuccessAndSyncEventsForWebSubscription.next({ event, toBeDismissedModalsCount });
  }

  emitPerPieceQcDefectOrRejectAddition(dto: TPerPieceDefectOrRejectAdditionDTO) {
    this.perPieceDefectOrRejectAdditionSubscription.next(dto);
  }

  getPerPieceQcDefectOrRejectAddition() {
    return this.perPieceDefectOrRejectAdditionSubscription.asObservable();
  }

  emitTriggerBctxChangeEvent() {
    this.triggerBctxChangeEvent.next(true);
  }

  getTriggerBctxChangeEvent() {
    return this.triggerBctxChangeEvent.asObservable();
  }

  emitShowPerPieceDefectiveSubscription(dto: TShowExistingPerPieceDefectiveDTO) {
    this.showPerPieceDefectiveSubscription.next(dto);
  }

  getShowPerPieceDefectiveSubscription() {
    return this.showPerPieceDefectiveSubscription.asObservable();
  }

  getStationChangeEvent() {
    return this.triggerStationChangeEvent.asObservable();
  }

  emitStationChangeEvent() {
    this.triggerStationChangeEvent.next();
  }

  getAllBctxItemsAcrossAllLinesAndMasterdataListConfig() {
    return this.store.pipe(select(getAllBctxItemsAcrossAllLinesAndMasterdataListConfig));
  }

  getUserDBLockDetailsAndNextCacheResetTime() {
    return this.store.pipe(select(getUserDBLockDetailsAndNextCacheResetTime));
  }

  getBgDBLockDetailsAndNextCacheResetTime() {
    return this.store.pipe(select(getBgDBLockDetailsAndNextCacheResetTime));
  }

  acquireUserDBLock(lockFor: TUserDBLockedBy): Observable<TUserDBLockResult> {
    return this.getUserDBLockDetailsAndNextCacheResetTime().pipe(
      take(1),
      map(({ lockDetails, nextCacheResetTimestamp }) => {
        if (lockDetails.isLocked) {
          return {
            status: 'FAILURE',
            lockedBy: lockDetails.lockedBy,
            message: `${this.translate.instant('input_app_image_db_effects.please_wait')} (${lockDetails.lockedBy})`,
          };
        } else if (lockFor !== 'INIT_PENDING' && nextCacheResetTimestamp < new Date().getTime()) {
          return {
            status: 'FAILURE',
            lockedBy: lockDetails.lockedBy,
            message: this.translate.instant('input_app_image_db_effects.factoryEndTime'),
          };
        } else {
          this.store.dispatch(
            new UpdateLockDetails(
              produce(lockDetails, (draft) => {
                draft.isLocked = true;
                draft.lockedBy = lockFor;
              }),
            ),
          );
          return {
            status: 'SUCCESS',
            lockedBy: lockFor,
          };
        }
      }),
    );
  }

  updatePerPieceCurrentActionInfo(currentActionInfo: TPerPieceQcCurrentActionInfo, stationId: string) {
    this.store.dispatch(new UpdatePerPieceQcCurrentActionInfo(currentActionInfo, stationId));
  }

  getPerPieceCurrentActionInfo() {
    return this.store.pipe(select(getCurrentLineActionInfo));
  }

  getLastForwardBulkEventBeforeUndoEvent() {
    return this.store.pipe(select(getLastForwardBulkEventBeforeUndoEvent));
  }

  getLastBulkCountEvent() {
    return this.store.pipe(select(getLastBulkCountEvent));
  }

  acquireBgDBLock(lockFor: TBgDBLockedBy): Observable<TBgDBLockResult> {
    return this.getBgDBLockDetailsAndNextCacheResetTime().pipe(
      take(1),
      map(({ lockDetails, nextCacheResetTimestamp }) => {
        if (lockDetails.isLocked) {
          return {
            status: 'FAILURE',
            lockedBy: lockDetails.lockedBy,
            message: `${this.translate.instant('input_app_image_db_effects.please_wait')} (${lockDetails.lockedBy})`,
          };
        } else if (lockFor !== 'INIT_PENDING' && nextCacheResetTimestamp < new Date().getTime()) {
          return {
            status: 'FAILURE',
            lockedBy: lockDetails.lockedBy,
            message: this.translate.instant('input_app_image_db_effects.factoryEndTime'),
          };
        } else if (lockFor === 'SYNC_EVENTS') {
          const metadata = lockDetails.metadata;
          const eventAdditionMetadata = metadata[lockFor];
          const currentTime = new Date().getTime();
          if (eventAdditionMetadata.nextLockUpto && eventAdditionMetadata.nextLockUpto >= currentTime) {
            return {
              status: 'FAILURE',
              lockedBy: 'NONE',
              message:
                this.translate.instant('input_app_image_db_effects.previousBatchSyncing.header') +
                this.translate.instant('input_app_image_db_effects.previousBatchSyncing.message'),
            };
          } else {
            this.store.dispatch(
              new UpdateBgDBLockDetails(
                produce(lockDetails, (draft) => {
                  draft.isLocked = true;
                  draft.lockedBy = 'SYNC_EVENTS';
                  draft.metadata['SYNC_EVENTS'] = {};
                }),
              ),
            );
            return {
              status: 'SUCCESS',
              lockedBy: 'SYNC_EVENTS',
            };
          }
        } else {
          this.store.dispatch(
            new UpdateBgDBLockDetails(
              produce(lockDetails, (draft) => {
                draft.isLocked = true;
                draft.lockedBy = lockFor;
              }),
            ),
          );
          return {
            status: 'SUCCESS',
            lockedBy: lockFor,
          };
        }
      }),
    );
  }

  acquireUserAndBgDBLock(lockFor: TCommonLockedBy) {
    return this.acquireBgDBLock(lockFor).pipe(
      take(1),
      switchMap((bgLockResult) => {
        return this.acquireUserDBLock(lockFor).pipe(
          take(1),
          map((userDBLockResult) => {
            return [bgLockResult, userDBLockResult] as const;
          }),
        );
      }),
    );
  }

  getselectedBctxItem() {
    return this.store.pipe(select(getselectedBctxInfo));
  }

  getselectedBctxItemAndOrderKeysAndBctxDisplayMap() {
    return this.store.pipe(select(getselectedBctxItemAndOrderKeysAndBctxDisplayMap));
  }

  getDefectiveMetadata() {
    return this.store.pipe(select(getDefectiveMetadata));
  }

  getConfigurations() {
    return this.store.pipe(select(getConfigurations));
  }

  getAppIdentifier() {
    return this.store.pipe(select(getAppIdentifier));
  }
  getReworkedEventsList() {
    return this.store.pipe(select(getReworkedEventsList));
  }

  getBctxViz() {
    return this.store.pipe(select(getBctxViz));
  }

  getDayStartTime() {
    return this.store.pipe(select(getNextCacheResetTimestamp)).pipe(
      map((res) => {
        return res - 86400000;
      }),
    );
  }

  getBctxKeysToDisplayMap() {
    return this.store.pipe(select(getBctxKeysToDisplayMap));
  }

  getBctxVizAndBctxItemsOrderWithoutSize() {
    return this.store.pipe(select(getBctxVizAndBctxItemsOrderWithoutSize));
  }

  notifyBctxChangeAndDismissModalForOfflineEnabledApps(selectedItem: TSelectedBctxInfo, dismissModal = true) {
    this.store.dispatch(new AcquireLockAndNotifyBctxChangeAndDismissModalAndReleaseLock(selectedItem, dismissModal));
  }

  fetchNewBctxSizeListAndInsertIntoDB(
    parentBctx: TBctxItemWithoutSizeAndBctxKey,
    childBctx: TNewBctxItemInPOSplit,
    currentSelectedBctxInfo: TSelectedBctxInfo, // Currently selected bctx stored in linemap
  ) {
    this.store.dispatch(new AcquireLockAndFetchNewBctxSizeList(parentBctx, childBctx, currentSelectedBctxInfo));
  }

  updateBctxWithoutChangeEvent(bctx: TBctxItemWithoutSizeAndBctxKey, newBctxForPOSplit?: TNewBctxItemInPOSplit) {
    this.store.dispatch(new AcquireLockAndUpdateBctxWithoutChangeEvent(bctx, newBctxForPOSplit));
  }

  notifyBctxChangeAndDismissModalForOnline(
    newBctx: TBctxItemWithoutSizeAndBctxKey,
    oldBctx: TBctxItemWithoutSizeAndBctxKey,
  ) {
    this.getSelectedStationIdAndShiftId()
      .pipe(take(1))
      .subscribe((res) => {
        this.store.dispatch(new AddBctxChangeEventForOnlineApps(oldBctx, newBctx, res.stationId));
      });
  }

  clearBctx() {
    this.store.dispatch(new AcquireLockAndClearSelectedBctxAndReleaseLock());
  }

  getBusinessContextListing() {
    return this.store.pipe(select(getBusinessContextListing));
  }

  getPositiveWipBusinessContextListing() {
    return this.store.pipe(select(getPositiveWipBusinessContextListing));
  }

  getBctxWipMap() {
    return this.store.pipe(select(getBctxWipMap));
  }

  getSizeList() {
    return this.store.pipe(select(getSizeList));
  }

  getPositiveWipSizeListByBctx(bctx: TBctxItemWithoutSize[]) {
    return this.store.pipe(select(getBctxWipMapWithOrderKeys)).pipe(
      take(1),
      map(({ wipMap, orderKeys }) => {
        const bctxKey = BCTXComputationHelper.getUniqueBctxKeyWithOrder(orderKeys, bctx);
        if (wipMap[bctxKey]) {
          return Object.entries(wipMap[bctxKey].sizeToWipMap)
            .filter(([key, value]) => {
              return value.wip_qty > 0;
            })
            .map(([key, value]) => key);
        } else return [];
      }),
    );
  }

  getSizeListByBctx(bctx: TBctxItemWithoutSize[]) {
    return this.store.pipe(select(getBctxWipMapWithOrderKeys)).pipe(
      take(1),
      map(({ wipMap, orderKeys }) => {
        const bctxKey = BCTXComputationHelper.getUniqueBctxKeyWithOrder(orderKeys, bctx);
        if (wipMap[bctxKey]) {
          return Object.entries(wipMap[bctxKey].sizeToWipMap).map(([key, value]) => key);
        } else return [];
      }),
    );
  }

  getSelectedStationIdAndShiftId() {
    return this.store.pipe(select(getSelectedStationIdAndShiftId));
  }

  getSelectedStationAndShiftDTO() {
    return this.store.pipe(select(getSelectedStationAndShiftDTO));
  }

  UpdateWipAndActuals(
    sizeName: string,
    actionType: TMDPointGradingPageAction,
    selectedBctx: TSelectedBctxInfo,
    selectedStationAndShiftId: TSelectedStationIdAndShiftId,
    count: number,
    undo: boolean,
  ) {
    this.store.dispatch(
      new UpdatedWipAndActuals(sizeName, actionType, selectedBctx, selectedStationAndShiftId, count, undo),
    );
  }

  getSaveEventsMetaData() {
    return combineLatest([
      from(this.authService.getDecodedJWTPromise()),
      this.getWhoObjectOfEventPayloadWithoutUserInfo(),
      this.getAppEventsApiPayloadWithoutDateTimeAndRecords(),
    ]).pipe(
      take(1),
      map(([decodedJWT, who, payloadWithoutDatetimeAndRecords]) => {
        return {
          who: {
            ...who,
            ur: { id: decodedJWT.usr, nm: decodedJWT.name },
          },
          payloadWithoutDatetimeAndRecords,
        };
      }),
    );
  }

  getWhoObjectOfEventPayloadWithoutUserInfo() {
    return this.store.pipe(select(getWhoObjectOfEventPayloadWithoutUserInfo));
  }

  getBusinessContextDataPayload() {
    return this.store.pipe(select(getBusinessContextDataPayload));
  }

  getBctxItemsOrderWithoutSize() {
    return this.store.pipe(select(getBctxItemsOrderWithoutSize));
  }

  getBctxItemsOrderForBackUp() {
    return this.store.pipe(select(getBctxItemsOrderForBackUp));
  }

  getBctxItemsOrder() {
    return this.store.pipe(select(getBuzKeys));
  }

  getAppEventsApiPayloadWithoutDateTimeAndRecords() {
    return this.store.pipe(select(getAppEventsApiPayloadWithoutDateTimeAndRecords));
  }

  saveEvent(actionType: TMDPointGradingPageAction) {
    this.store.dispatch(new SaveEvents(actionType));
  }

  getRestorePayload() {
    return this.store.pipe(select(getRestoreApiPayload));
  }

  getRestorePayloadForBackedUpBctx() {
    return this.store.pipe(select(getLineAndShiftRestorePayload));
  }

  restoreAppState(bctxWithMultipleSizeList: TBctxWithMultipleSize[], wip_only: boolean = false) {
    this.getClientDBAndOnlineStatusAndEventsBatchCountAndCurrentLineAndShift()
      .pipe(take(1))
      .subscribe(({ isOnline, userDB, bgDB }) => {
        if (isOnline && !EventUtil.hasAnyPendingEvents(userDB, bgDB)) {
          this.store.dispatch(new AcquireLockAndThenRestoreActuals(bctxWithMultipleSizeList, wip_only));
        } else {
          this.inputAppErrorDisplayUtil.showPopup(
            this.translate.instant('input_app_common.error'),
            !isOnline
              ? this.translate.instant('input_app_db_facade.noInternet')
              : this.translate.instant('input_app_db_facade.cannotRestore'),
          );
        }
      });
  }

  restoreAppStateForBackedUpBctx(
    updateActualsOnly: boolean,
    dto: TRestoreBackedUpBctx,
    isBgDBUnlocked: boolean,
    reconcileIsCompleted: boolean,
  ) {
    this.getClientDBAndOnlineStatusAndEventsBatchCountAndCurrentLineAndShift()
      .pipe(take(1))
      .subscribe(({ isOnline, userDB, bgDB, batchCount }) => {
        if (!isOnline)
          this.inputAppErrorDisplayUtil.showPopup(
            this.translate.instant('input_app_common.error'),
            this.translate.instant('input_app_db_facade.noInternet'),
          );
        else if (!isBgDBUnlocked) {
          this.pollForBgDBLock(updateActualsOnly, { chainWithRestoreWipAndActualsForBackedUpBctx: dto });
        } else if (EventUtil.hasAnyPendingEvents(userDB, bgDB)) {
          this.store.dispatch(
            new AcquireBgDBLockAndThenSyncEvents(updateActualsOnly, true, batchCount, {
              chainWithRestoreWipAndActualsForBackedUpBctx: dto,
            }),
          );
        } else if (!reconcileIsCompleted)
          this.store.dispatch(
            new AcquireUserDBLockAndBgDBLockAndReconcile(updateActualsOnly, true, {
              chainWithRestoreWipAndActualsForBackedUpBctx: dto,
            }),
          );
        else this.store.dispatch(new AcquireUserDBLockAndThenRestoreActualsForBackedUpBctx(dto));
      });
  }

  reconcileAndShowErrorForAppUpdates(updateActualsOnly: boolean, dto: TRemoteDeploymentCheckWithEventsSyncResult) {
    this.store.dispatch(
      new AcquireUserDBLockAndBgDBLockAndReconcile(updateActualsOnly, true, {
        reconcileAndShowAppUpdateError: dto,
      }),
    );
  }

  //Reconcile is needed because if previous days events gets synced and today events fails, then from the error popup
  //next actions can be bctx sync etc, which assumes Reconcile is already done
  forceSyncEventsAndUpdateApp(updateActualsOnly: boolean, dto: TRemoteDeploymentCheck, isBgDBUnlocked: boolean) {
    this.getClientDBAndOnlineStatusAndEventsBatchCountAndCurrentLineAndShift()
      .pipe(take(1))
      .subscribe(({ isOnline, userDB, bgDB, batchCount }) => {
        if (!isBgDBUnlocked) {
          this.pollForBgDBLock(updateActualsOnly, { chainWithAppUpdate: dto });
        } else if (!isOnline) {
          this.reconcileAndShowErrorForAppUpdates(updateActualsOnly, {
            syncResult: {
              status: 'NO_INTERNET_FOR_SYNCING_PENDING_EVENTS',
            },
            remoteDeploymentcheck: dto,
          });
        } else if (EventUtil.hasAnyPendingEvents(userDB, bgDB)) {
          this.store.dispatch(
            new AcquireBgDBLockAndThenSyncEvents(updateActualsOnly, true, batchCount, {
              chainWithAppUpdate: dto,
            }),
          );
        } else {
          this.reconcileAndShowErrorForAppUpdates(updateActualsOnly, {
            syncResult: {
              status: 'ALL_SYNCED',
            },
            remoteDeploymentcheck: dto,
          });
        }
      });
  }

  syncAppStateForOnlineApps() {
    this.getClientDBAndOnlineStatusAndEventsBatchCountAndCurrentLineAndShift()
      .pipe(take(1))
      .subscribe(({ isOnline, userDB, bgDB }) => {
        if (isOnline && !EventUtil.hasAnyPendingEvents(userDB, bgDB)) {
          this.store.dispatch(
            new AcquireUserDBLockAndSyncStyleInfo(
              false,
              { discardWipUpdates: false },
              { chainWithRestoreActualsForNewStyles: true },
            ),
          );
        } else {
          this.inputAppErrorDisplayUtil.showPopup(
            this.translate.instant('input_app_common.error'),
            !isOnline
              ? this.translate.instant('input_app_db_facade.noInternet')
              : this.translate.instant('input_app_db_facade.cannotUpdateWip'),
          );
        }
      });
  }

  initializeReduxStore() {
    this.store.dispatch(new InitializeReduxStore());
  }

  getActionTypeToTotalActualsMap() {
    return this.store.pipe(select(getActionTypeToTotalActualsMap));
  }

  getAllBctxActualsMap() {
    return this.store.pipe(select(getAllBctxActualsMap));
  }

  getAllBctxActualsMapPerPiece() {
    return this.store.pipe(select(getAllBctxActualsMapPerPiece));
  }

  LoadToBeRectifiedData(filters: TREQUEST_ToBeRectifiedListing['filters'], paginationInfo: TUserPaginationOption) {
    this.store.dispatch(new AcquireUserDBLockAndLoadToBeRectifiedData(filters, paginationInfo));
  }

  updateIncompleteBundlesInfo(incompleteBundlesInfo: TIncompleteBundlesInfo) {
    this.store.dispatch(new AcquireUserDBLockAndUpdateIncompleteBundlesInfo(incompleteBundlesInfo));
  }

  RestoreToBeRectifiedCounts(payload: TREQUEST_RestoreToBeRectifiedCounts['bctxItems']) {
    this.store.dispatch(new RestoreToBeRectifiedCountsAndThenReleaseLock(payload));
  }

  saveToBeRectifiedCount(
    actionType: TToBeRectifiedSaveEventActionType,
    payload: TToBeRectifiedDTO[],
    filters: TREQUEST_ToBeRectifiedListing['filters'],
    paginationInfo: TUserPaginationOption,
  ) {
    this.store.dispatch(new ToBeRectifiedSaveEvents(actionType, payload, filters, paginationInfo));
  }

  getStationDetails() {
    return this.store.pipe(select(getStationDetails));
  }

  getStationDetailsAndSelectedBctxItem() {
    return this.store.pipe(select(getStationDetailsAndSelectedBctxItem));
  }

  getToBeRectifiedListing() {
    return this.store.pipe(select(getToBeRectifiedListing));
  }

  clearToBeRectifiedListing() {
    this.store.dispatch(new AcquireUserDBLockAndClearToBeRectifiedList());
  }

  getRectifiedBCTXKeysInfo() {
    return this.store.pipe(select(getRectifiedBCTXKeysInfo));
  }

  getBctxItemAndSizeList() {
    return this.store.pipe(select(getBctxItemAndSizeList));
  }

  getBackUpDataStatus() {
    return from(this.persistanceStorageService.get('[APP][INPUT_APP_BACK_UP_DATA_STATUS]')).pipe(take(1));
  }

  setBackUpDataStatus(backUpDB: TBackUpDataStatusDB) {
    return from(this.persistanceStorageService.set('[APP][INPUT_APP_BACK_UP_DATA_STATUS]', backUpDB)).pipe(take(1));
  }

  getPastDaySyncedEventsDB() {
    return from(this.persistanceStorageService.get('[APP][INPUT_APP_PAST_DAY_SYNCED_EVENTS_DB]')).pipe(take(1));
  }

  setPastDaySyncedEventsDB(pastDaySyncedEventsDB: TPastDaySyncedEventsDB) {
    return from(
      this.persistanceStorageService.set('[APP][INPUT_APP_PAST_DAY_SYNCED_EVENTS_DB]', pastDaySyncedEventsDB),
    ).pipe(take(1));
  }

  getClientDB() {
    return this.store.pipe(select(selectInputAppDB));
  }

  getClientDBNextCacheResetTimestamp() {
    return this.store.pipe(select(getUserDBNextCacheResetTimestamp));
  }

  getClientDBAndBgDB() {
    return this.store.pipe(select(getClientDBAndBgDB));
  }

  getClientDBAndOnlineStatusAndEventsBatchCountAndCurrentLineAndShift() {
    return this.store.pipe(select(getClientDBAndOnlineStatusAndEventsBatchCountAndCurrentLineAndShift));
  }

  getMergedLineMapAndSelectedStationIdAndShiftId() {
    return this.store.pipe(select(getMergedLineMapAndSelectedStationIdAndShiftId));
  }

  getUserDBAndBgDBLockDetails() {
    return this.store.pipe(select(getUserDBAndBgDBLockDetails));
  }

  isUserAndBgDBsUnlocked() {
    return this.getUserDBAndBgDBLockDetails().pipe(
      take(1),
      map(({ userDBLockDetails, bgDBLockDetails }) => !userDBLockDetails.isLocked && !bgDBLockDetails.isLocked),
    );
  }

  updateSelectedBctxOfLocalDBForCurrentStation(selectedBctxInfo: TSelectedBctxInfo) {
    return this.getSelectedStationIdAndShiftId().pipe(
      take(1),
      switchMap(({ stationId }) => {
        return from(this.persistanceStorageService.get('[APP][INPUT_APP_CLIENT_DB]')).pipe(
          take(1),
          switchMap((currentLocalDB) => {
            const updatedDB = produce(currentLocalDB, (draft) => {
              draft.dailyCache.lineMap[stationId].selectedBctxInfo = selectedBctxInfo;
            });
            return from(this.persistanceStorageService.set('[APP][INPUT_APP_CLIENT_DB]', updatedDB)).pipe(
              take(1),
              map(() => updatedDB),
            );
          }),
        );
      }),
    );
  }

  getSizeMapFromLocalDB(selectedStationAndShiftId: TSelectedStationIdAndShiftId) {
    return this.getselectedBctxItem().pipe(
      take(1),
      switchMap((selectedBctxItem) => {
        return from(this.persistanceStorageService.get('[APP][INPUT_APP_CLIENT_DB]')).pipe(
          take(1),
          switchMap((userDB) => {
            return from(this.persistanceStorageService.get('[APP][INPUT_APP_BACKGROUND_EVENTS_SYNCING_DB]')).pipe(
              take(1),
              map((bgDB) => {
                const mergedLineMap = BCTXComputationHelper.mergeUserLineMapWithBgLineMap(
                  userDB.dailyCache.lineMap,
                  bgDB.dailyCache.lineMap,
                );
                const bctxKey = selectedBctxItem.bctxInfoWithoutSize.bctxKey;
                const newBctxKey = selectedBctxItem.newBctxForPOSplit?.bctx.bctxKey;
                const { stationId, shiftId } = selectedStationAndShiftId;
                // Return client work done for new Bctx in case of PO Split
                return mergedLineMap[stationId].shiftMap[shiftId].clientBctx[newBctxKey ? newBctxKey : bctxKey].sizeMap;
              }),
            );
          }),
        );
      }),
    );
  }

  getFullSaveEventPayload(events: TBulkEvent[], syncedTime: number) {
    return this.getBctxVizAndBctxItemsOrderWithoutSize().pipe(
      take(1),
      switchMap(([bctxViz]) => {
        return this.getSaveEventsMetaData().pipe(
          take(1),
          map(({ who, payloadWithoutDatetimeAndRecords }) => {
            const records = [] as TREQUEST_AppEventsRequestDTO['records'];
            events.forEach((bulkEvent) => {
              const stationDetails = bulkEvent.metadata.stationDetails;
              bulkEvent.events.forEach((singleEvent) => {
                records.push({
                  key: (records.length + 1).toString(),
                  value: {
                    unique_event_id: singleEvent.eventInfo.v_id,
                    linked_event_id: singleEvent.eventInfo.linked_v_id,
                    v_id: singleEvent.eventInfo.v_id,
                    a: EventUtil.getAboutObject(stationDetails, singleEvent, bctxViz),
                    w1: EventUtil.getWhenObjectOfSaveEvent(singleEvent),
                    w2: {
                      ...who,
                      mi: bulkEvent.metadata.eventTime + '-' + singleEvent.eventBackgroundMetadata.eventId,
                    },
                    w3:
                      singleEvent.type === 'FORWARD_EVENT' || singleEvent.type === 'UNDO_EVENT'
                        ? EventUtil.getWhatObjectOfSaveEvent(singleEvent, who.ad)
                        : EventUtil.getWhatObjectOfNonCountEvent(singleEvent, bctxViz, who.ad),
                    ei: {
                      id: singleEvent.eventBackgroundMetadata.eventId,
                      dt: bulkEvent.metadata.eventTime,
                    },
                  },
                });
              });
            });
            return {
              ...payloadWithoutDatetimeAndRecords,
              records,
              datetime: syncedTime,
            } as TREQUEST_AppEventsRequestDTO;
          }),
        );
      }),
    );
  }

  syncAtLeastOnePendingBulkEventWithBatchCountWrapper(
    bulkEvents: TBulkEvent[],
    batchCount: number,
    appIdentifier?: TAppIdentifier,
  ) {
    return this.syncAtLeastOnePendingBulkEventWithBatchCount(
      { bulkEvents, lastBatchSyncStatus: 'YET_TO_BE_SYNCED', failedBulkEventsIndexes: [] },
      batchCount,
      appIdentifier,
    );
  }

  releaseUserDBLock() {
    this.getUserDBLockDetailsAndNextCacheResetTime()
      .pipe(take(1))
      .subscribe(({ lockDetails }) => {
        this.store.dispatch(new UpdateLockDetails(BCTXComputationHelper.releaseUserDBLock(lockDetails)));
      });
  }

  releaseBgDBLock() {
    this.getBgDBLockDetailsAndNextCacheResetTime()
      .pipe(take(1))
      .subscribe(({ lockDetails }) => {
        this.store.dispatch(new UpdateBgDBLockDetails(BCTXComputationHelper.releaseBgLock(lockDetails)));
      });
  }

  pollForBgDBLock(updateActualsOnly: boolean, userAction: TUserAction, hasLoaderShown = false) {
    this.acquireUserDBLock('POLLING_FOR_BG_LOCK')
      .pipe(take(1))
      .subscribe(async (userDBLockDetails) => {
        if (userDBLockDetails.status === 'SUCCESS') {
          this.acquireBgDBLock('POLLING_FOR_BG_LOCK')
            .pipe(take(1))
            .subscribe(async (bgDBLockDetails) => {
              if (bgDBLockDetails.status === 'SUCCESS') {
                if (hasLoaderShown) await this.inputAppErrorDisplayUtil.dismissLoadingWithId('POLL_FOR_EVENTS_BG_LOCK');
                this.releaseUserDBLock();
                this.releaseBgDBLock();
                if (userAction.chainWithReFetchWip)
                  this.forceSyncWipAfterSyncingAllPendingEvents(updateActualsOnly, true, false);
                else if (userAction.chainWithRestoreWipAndActualsForBackedUpBctx) {
                  this.restoreAppStateForBackedUpBctx(
                    updateActualsOnly,
                    userAction.chainWithRestoreWipAndActualsForBackedUpBctx,
                    true,
                    false,
                  );
                } else if (userAction.chainWithUndo)
                  this.forceUndoEventAfterSyncingAllPendingEvents(
                    updateActualsOnly,
                    userAction.chainWithUndo,
                    true,
                    false,
                  );
                else if (userAction.chainWithInitForLineChange)
                  this.forceInitLineChangeAfterSyncingAllPendingEvents(
                    updateActualsOnly,
                    true,
                    false,
                    userAction.chainWithInitForLineChange,
                  );
                else if (userAction.chainWithReFetchServerDefectives) {
                  this.fetchServerDefectivesAfterSyncingAllPendingEvents(updateActualsOnly, true);
                } else if (userAction.chainWithPerPieceLineInUndo) {
                  this.forcePerPieceLineInUndoAfterSyncingAllPendingEvents(
                    updateActualsOnly,
                    userAction.chainWithPerPieceLineInUndo,
                    true,
                    false,
                  );
                } else if (userAction.chainWithPerPieceQcUndo) {
                  this.forcePerPieceQcUndoEventAfterSyncingAllPendingEvents(
                    updateActualsOnly,
                    userAction.chainWithPerPieceQcUndo,
                    true,
                    false,
                  );
                } else if (userAction.chainWithLogout) {
                  this.forceLogoutAfterSyncingAllPendingEvents(updateActualsOnly, true, false);
                } else if (userAction.chainWithAppUpdate) {
                  this.forceSyncEventsAndUpdateApp(updateActualsOnly, userAction.chainWithAppUpdate, true);
                }
              } else {
                if (!hasLoaderShown)
                  await this.inputAppErrorDisplayUtil.presentLoadingWithId(
                    'POLL_FOR_EVENTS_BG_LOCK',
                    this.translate.instant('input_app_db_facade.evaluatingPendingEvents'),
                  );
                setTimeout(() => {
                  this.releaseUserDBLock();
                  this.pollForBgDBLock(updateActualsOnly, userAction, true);
                }, 2000);
              }
            });
        } else {
          if (hasLoaderShown) await this.inputAppErrorDisplayUtil.dismissLoadingWithId('POLL_FOR_EVENTS_BG_LOCK');
          this.inputAppErrorDisplayUtil.showPopup(
            this.translate.instant('input_app_common.error'),
            userDBLockDetails.message,
          );
        }
      });
  }

  insertBctxKeysFromBulkEvent(bulkEvent: TBulkEvent, bctxKeys: Set<string>, appIdentifier?: TAppIdentifier) {
    if (
      this.isPerPieceAppIdentifier(appIdentifier) &&
      (bulkEvent.type === 'FORWARD_BULK_EVENT' || bulkEvent.type === 'UNDO_BULK_EVENT')
    ) {
      bulkEvent.events.forEach((event) => {
        bctxKeys.add(event.eventInfo.bctxDetails.bctxKey);
      });
    }
    return bctxKeys;
  }

  isPerPieceAppIdentifier(appIdentifier?: TAppIdentifier) {
    return (
      appIdentifier === 'md_point_per_piece_qc_v2' ||
      appIdentifier === 'per_piece_line_in_v2' ||
      appIdentifier === 'per_piece_qc_v2'
    );
  }

  validateBctxKeysFromBulkEvent(bulkEvent: TBulkEvent, bctxKeys: Set<string>, appIdentifier?: TAppIdentifier) {
    if (
      this.isPerPieceAppIdentifier(appIdentifier) &&
      (bulkEvent.type === 'FORWARD_BULK_EVENT' || bulkEvent.type === 'UNDO_BULK_EVENT')
    ) {
      return !bulkEvent.events.some((event) => {
        return bctxKeys.has(event.eventInfo.bctxDetails.bctxKey);
      });
    }
    return true;
  }

  getToBeSyncedEventsDTO(
    bulkEvents: TBulkEvent[],
    batchCount: number,
    lastSyncedIndex: number,
    appIdentifier?: TAppIdentifier,
  ): TToBeSyncedEventsDTO {
    const toBeSyncedBulkEvents = [] as TBulkEvent[];
    const groupIdToIndexMap: Record<string, number> = {};

    // Get the subject of the first event to sync
    const targetSubject = bulkEvents[lastSyncedIndex + 1].metadata.stationDetails.subject;

    //No need of validation here, because every event in bulkEvent will have a different bctxKey
    let bctxKeys = this.insertBctxKeysFromBulkEvent(bulkEvents[lastSyncedIndex + 1], new Set<string>(), appIdentifier);
    let currentEventsCount = bulkEvents[lastSyncedIndex + 1].events.length;

    toBeSyncedBulkEvents.push(bulkEvents[lastSyncedIndex + 1]);
    groupIdToIndexMap[bulkEvents[lastSyncedIndex + 1].metadata.groupId] = lastSyncedIndex + 1;
    for (
      let index = lastSyncedIndex + 2;
      index < bulkEvents.length &&
      currentEventsCount + bulkEvents[index].events.length <= batchCount &&
      bulkEvents[index].metadata.stationDetails.subject.subject === targetSubject.subject && // Stop if subject changes - no jumping
      this.validateBctxKeysFromBulkEvent(bulkEvents[index], bctxKeys, appIdentifier);
      index++
    ) {
      bctxKeys = this.insertBctxKeysFromBulkEvent(bulkEvents[index], bctxKeys, appIdentifier);
      toBeSyncedBulkEvents.push(bulkEvents[index]);
      currentEventsCount += bulkEvents[index].events.length;
      groupIdToIndexMap[bulkEvents[index].metadata.groupId] = index;
    }

    const vIdToGroupIdMap: Record<string, string> = {};
    toBeSyncedBulkEvents.forEach((bulkEvent) => {
      bulkEvent.events.forEach((event) => {
        vIdToGroupIdMap[event.eventInfo.v_id] = bulkEvent.metadata.groupId;
      });
    });
    return {
      toBeSyncedBulkEvents,
      groupIdToIndexMap,
      vIdToGroupIdMap,
    };
  }

  syncAtLeastOnePendingBulkEventWithBatchCount(
    syncEventsDTO: TSyncEventsDTO,
    batchCount: number,
    appIdentifier?: TAppIdentifier,
  ): Observable<TSyncEventsDTO> {
    let { bulkEvents, failedBulkEventsIndexes } = syncEventsDTO;
    let lastSyncedIndex = EventUtil.getLastSyncedIndex(bulkEvents);
    if (lastSyncedIndex === bulkEvents.length - 1) {
      return of({
        bulkEvents,
        failedBulkEventsIndexes,
        lastBatchSyncStatus: 'ALL_SYNCED',
      });
    } else {
      const { toBeSyncedBulkEvents, groupIdToIndexMap, vIdToGroupIdMap } = this.getToBeSyncedEventsDTO(
        bulkEvents,
        batchCount,
        lastSyncedIndex,
        appIdentifier,
      );
      const syncedTime = new Date().getTime();
      return this.getFullSaveEventPayload(toBeSyncedBulkEvents, syncedTime).pipe(
        take(1),
        switchMap((saveEventsPayload: TREQUEST_AppEventsRequestDTO) =>
          this.inputAppDataService.saveEvent(saveEventsPayload).pipe(
            take(1),
            switchMap((res) => {
              const eventsSyncedTime = new Date().getTime();
              const groupedRecordsByBulkEvent = _.groupBy(res.records, (record) => vIdToGroupIdMap[record.v_id]);
              Object.entries(groupedRecordsByBulkEvent).forEach(([groupId, records]) => {
                if (records.some((record) => !record.valid)) {
                  failedBulkEventsIndexes = produce(failedBulkEventsIndexes, (draft) => {
                    draft.push(groupIdToIndexMap[groupId]);
                  });
                }
                records.forEach((record) => {
                  const bulkEvent = bulkEvents[groupIdToIndexMap[groupId]];
                  const eventIndex = EventUtil.getIndexByVId(bulkEvent, record.v_id);
                  bulkEvents = produce(bulkEvents, (draft) => {
                    const event = draft[groupIdToIndexMap[groupId]].events[eventIndex];
                    if (!record.valid) {
                      event.eventBackgroundMetadata.status = 'VALIDATION_ERROR';
                      event.eventBackgroundMetadata.errorDetails = record.failure_info;
                    } else {
                      event.eventBackgroundMetadata.status = 'SYNCED_WITH_SUCCESS';
                    }
                  });
                });
                bulkEvents = produce(bulkEvents, (draft) => {
                  if (
                    draft[groupIdToIndexMap[groupId]].events.some(
                      (event) => event.eventBackgroundMetadata.status === 'SYNCED_WITH_SUCCESS',
                    )
                  ) {
                    draft[groupIdToIndexMap[groupId]].backgroundMetadata.bulkEventStatus = 'SYNCED';
                    draft[groupIdToIndexMap[groupId]].backgroundMetadata.syncedTime = eventsSyncedTime;
                  } else {
                    draft[groupIdToIndexMap[groupId]].backgroundMetadata.bulkEventStatus =
                      'TVALIDATION_ERROR_FOR_ALL_EVENTS';
                    draft[groupIdToIndexMap[groupId]].backgroundMetadata.syncedTime = eventsSyncedTime;
                  }
                });
              });
              return this.syncAtLeastOnePendingBulkEventWithBatchCount(
                {
                  bulkEvents,
                  failedBulkEventsIndexes,
                  lastBatchSyncStatus: 'YET_TO_BE_SYNCED',
                },
                batchCount,
                appIdentifier,
              );
            }),
            catchError((error: HttpResponseException) => {
              const eventsSyncedTime = new Date().getTime();
              const status = error.httpResponse.status;
              this.customLoggerService.log('INPUT APP CLIENT DB FACADE', 'Error in syncAtLeastOnePendingBulkEventWithBatchCount catchError', {
                bulkEvents,
                eventsSyncedTime,
                failedBulkEventsIndexes,
                status: status,
                error: error?.name + ' - ' + error?.message,
              });
              switch (status) {
                case 500: {
                  toBeSyncedBulkEvents.forEach((event) => {
                    const bulkEventIndex = groupIdToIndexMap[event.metadata.groupId];
                    if (event.backgroundMetadata.remainingRetriesCount <= 0) {
                      failedBulkEventsIndexes = produce(failedBulkEventsIndexes, (draft) => {
                        draft.push(bulkEventIndex);
                      });
                      bulkEvents = produce(bulkEvents, (draft) => {
                        draft[bulkEventIndex].backgroundMetadata.bulkEventStatus = 'SERVER_ERROR';
                        draft[bulkEventIndex].backgroundMetadata.errorDetails = {};
                        draft[bulkEventIndex].backgroundMetadata.syncedTime = eventsSyncedTime;
                      });
                      event.events.forEach((event) => {
                        const eventIndex = EventUtil.getIndexByVId(
                          bulkEvents[bulkEventIndex],
                          event.eventBackgroundMetadata.v_id,
                        );
                        bulkEvents = produce(bulkEvents, (draft) => {
                          draft[bulkEventIndex].events[eventIndex].eventBackgroundMetadata.status = 'SERVER_ERROR';
                          draft[bulkEventIndex].events[eventIndex].eventBackgroundMetadata.errorDetails = {
                            failure_type: 'SERVER_ERROR',
                            reason: this.translate.instant('input_app_client_db_facade.unableToSync'),
                          };
                        });
                      });
                    } else {
                      bulkEvents = produce(bulkEvents, (draft) => {
                        draft[bulkEventIndex].backgroundMetadata.remainingRetriesCount--;
                      });
                    }
                  });
                  return of({
                    bulkEvents: bulkEvents,
                    failedBulkEventsIndexes: failedBulkEventsIndexes,
                    lastBatchSyncStatus: 'SERVER_ERROR' as TSyncEventStatus,
                  });
                }
                // Cross Origin issue network status will return 0
                case 0: {
                  return of({
                    bulkEvents: bulkEvents,
                    failedBulkEventsIndexes: failedBulkEventsIndexes,
                    lastBatchSyncStatus: 'NO_INTERNET' as TSyncEventStatus,
                  });
                }
                default: {
                  return of({
                    bulkEvents: bulkEvents,
                    failedBulkEventsIndexes: failedBulkEventsIndexes,
                    lastBatchSyncStatus: 'UNKNOWN_ERROR' as TSyncEventStatus,
                  });
                }
              }
            }),
          ),
        ),
      );
    }
  }

  // This function is currently used for syncing events directly from the app level.
  // Most likely, events related to different subjects are not expected here.
  syncAllBulkEvent(syncEventsDTO: TSyncEventsDTO, startIndex: number = 0): Observable<TSyncEventsDTO> {
    let { bulkEvents, failedBulkEventsIndexes } = syncEventsDTO;

    if (startIndex >= bulkEvents.length) {
      return of({
        bulkEvents,
        failedBulkEventsIndexes,
        lastBatchSyncStatus: 'ALL_SYNCED' as TSyncEventStatus,
      });
    }
    const targetSubject = bulkEvents[startIndex].metadata.stationDetails.subject.subject;

    const toBeSyncedBulkEvents: TBulkEvent[] = [];
    const groupIdToIndexMap: Record<string, number> = {};
    let nextStartIndex = bulkEvents.length;

    for (let index = startIndex; index < bulkEvents.length; index++) {
      const currentEvent = bulkEvents[index];
      if (currentEvent.metadata.stationDetails.subject.subject !== targetSubject) {
        nextStartIndex = index;
        break;
      }
      toBeSyncedBulkEvents.push(currentEvent);
      groupIdToIndexMap[currentEvent.metadata.groupId] = index;
    }

    const vIdToGroupIdMap: Record<string, string> = {};
    toBeSyncedBulkEvents.forEach((bulkEvent) => {
      bulkEvent.events.forEach((event) => {
        vIdToGroupIdMap[event.eventInfo.v_id] = bulkEvent.metadata.groupId;
      });
    });

    const syncedTime = new Date().getTime();
    return this.getFullSaveEventPayload(toBeSyncedBulkEvents, syncedTime).pipe(
      take(1),
      switchMap((saveEventsPayload: TREQUEST_AppEventsRequestDTO) =>
        this.inputAppDataService.saveEvent(saveEventsPayload).pipe(
          take(1),
          switchMap((res) => {
            const eventsSyncedTime = new Date().getTime();
            const groupedRecordsByBulkEvent = _.groupBy(res.records, (record) => vIdToGroupIdMap[record.v_id]);
            Object.entries(groupedRecordsByBulkEvent).forEach(([groupId, records]) => {
              if (records.some((record) => !record.valid)) {
                failedBulkEventsIndexes = produce(failedBulkEventsIndexes, (draft) => {
                  draft.push(groupIdToIndexMap[groupId]);
                });
              }
              records.forEach((record) => {
                const bulkEvent = bulkEvents[groupIdToIndexMap[groupId]];
                const eventIndex = EventUtil.getIndexByVId(bulkEvent, record.v_id);
                bulkEvents = produce(bulkEvents, (draft) => {
                  const event = draft[groupIdToIndexMap[groupId]].events[eventIndex];
                  if (!record.valid) {
                    event.eventBackgroundMetadata.status = 'VALIDATION_ERROR';
                    event.eventBackgroundMetadata.errorDetails = record.failure_info;
                  } else {
                    event.eventBackgroundMetadata.status = 'SYNCED_WITH_SUCCESS';
                  }
                });
              });
              bulkEvents = produce(bulkEvents, (draft) => {
                if (
                  draft[groupIdToIndexMap[groupId]].events.some(
                    (event) => event.eventBackgroundMetadata.status === 'SYNCED_WITH_SUCCESS',
                  )
                ) {
                  draft[groupIdToIndexMap[groupId]].backgroundMetadata.bulkEventStatus = 'SYNCED';
                  draft[groupIdToIndexMap[groupId]].backgroundMetadata.syncedTime = eventsSyncedTime;
                } else {
                  draft[groupIdToIndexMap[groupId]].backgroundMetadata.bulkEventStatus =
                    'TVALIDATION_ERROR_FOR_ALL_EVENTS';
                  draft[groupIdToIndexMap[groupId]].backgroundMetadata.syncedTime = eventsSyncedTime;
                }
              });
            });
            return this.syncAllBulkEvent(
              {
                bulkEvents,
                failedBulkEventsIndexes,
                lastBatchSyncStatus: 'YET_TO_BE_SYNCED',
              },
              nextStartIndex,
            );
          }),
          catchError((error: HttpResponseException) => {
            const status = error?.httpResponse?.status;
            this.customLoggerService.log('INPUT APP CLIENT DB FACADE', 'Error in syncAllBulkEvent catchError', {
              bulkEvents,
              failedBulkEventsIndexes,
              status: status,
              error: error?.name + ' - ' + error?.message,
            });
            switch (status) {
              case 500: {
                return of({
                  bulkEvents: bulkEvents,
                  failedBulkEventsIndexes: failedBulkEventsIndexes,
                  lastBatchSyncStatus: 'SERVER_ERROR' as TSyncEventStatus,
                });
              }
              // Cross Origin issue network status will return 0
              case 0: {
                return of({
                  bulkEvents: bulkEvents,
                  failedBulkEventsIndexes: failedBulkEventsIndexes,
                  lastBatchSyncStatus: 'NO_INTERNET' as TSyncEventStatus,
                });
              }
              default: {
                return of({
                  bulkEvents: bulkEvents,
                  failedBulkEventsIndexes: failedBulkEventsIndexes,
                  lastBatchSyncStatus: 'UNKNOWN_ERROR' as TSyncEventStatus,
                });
              }
            }
          }),
        ),
      ),
    );
  }

  getEventsArray() {
    return this.store.pipe(select(getEventsArray));
  }

  getPendingEventsArray() {
    return this.store.pipe(select(getPendingEvents));
  }

  getTodayAndPastDaysMergedEvents() {
    return this.store.pipe(select(getTodayAndPastDaysMergedEvents));
  }

  getActivityLogEvents() {
    return this.store.pipe(select(getActivityLogEvents));
  }

  getActivityLogPastDayEvents() {
    return combineLatest([
      this.getPastDaySyncedEventsDB().pipe(
        take(1),
        map(({ listOfPastDaysEventsWhichAreSynced }) => {
          return listOfPastDaysEventsWhichAreSynced || [];
        }),
      ),
      this.store.pipe(select(getPastDayYetToBeSyncedEvents)),
    ]).pipe(
      map(([syncedEvents, yetToBeSyncedEvents]) => {
        return [...syncedEvents, ...yetToBeSyncedEvents] as TActivityLogEvent[];
      }),
    );
  }

  acquireLockAndThenAddBulkEvents(
    events: TBulkEventWithoutStatus[],
    showLoader: boolean,
    eventAdditionMoreActions: TEventAddtionMoreActions,
    eventAdditionSideActions?: TEventAddtionSideActions,
  ) {
    this.store.dispatch(
      new AcquireUserDBLockAndAddBulkEvents(events, showLoader, eventAdditionMoreActions, eventAdditionSideActions),
    );
  }
  AcquireUserDBLockAndHandleSideActions(
    eventAdditionMoreActions: TEventAddtionMoreActions,
    eventAdditionSideActions?: TEventAddtionSideActions,
  ) {
    this.store.dispatch(new AcquireUserDBLockAndHandleSideActions(eventAdditionMoreActions, eventAdditionSideActions));
  }

  acquireLockAndCheckValidEventsAndThenAddBulkEvents(
    events: TBulkEventWithoutStatus[],
    eventAdditionMoreActions: TEventAddtionMoreActions,
    eventAdditionSideActions?: TEventAddtionSideActions,
    rfidScannerBulkMode: boolean = false,
  ) {
    this.store.dispatch(
      new AcquireUserBgDBLockAndCheckEventsValidAndThenAddBulkEvents(
        events,
        eventAdditionMoreActions,
        eventAdditionSideActions,
        rfidScannerBulkMode,
      ),
    );
  }

  getBulkEventMetadata(eventTime: number, location: TEventLocation) {
    return this.getSelectedStationAndShiftDTO().pipe(
      take(1),
      map((selectedStationAndShiftDTO) => {
        return EventUtil.getYetToBeSyncedBulkEventMetadata(
          location,
          {
            shift: (selectedStationAndShiftDTO as unknown as TEventStationDetails).shift,
            subject: (selectedStationAndShiftDTO as unknown as TEventStationDetails).subject,
          },
          eventTime,
        );
      }),
    );
  }

  getEventsCommonDetails(
    linkedVIdAndBctxList: { linked_v_id?: string; bctxDetails: TEventBctxDetails }[],
    eventTime: number,
  ) {
    return linkedVIdAndBctxList.map((linkedVidAndBctx) => {
      const bctxDetails = linkedVidAndBctx.bctxDetails;
      return EventUtil.getYetToBeSyncedEventCommonDetails(
        {
          size: bctxDetails.size,
          count: bctxDetails.count,
          businessContextDetailsWithoutSize: bctxDetails.businessContextDetailsWithoutSize,
          bctxKey: bctxDetails.bctxKey,
          newBctxDetails: bctxDetails.newBctxDetails,
        },
        eventTime,
        linkedVidAndBctx.linked_v_id,
      );
    });
  }

  getUniqueBctxKeyFromBctxItemsWithoutSize(bctxItemsWithoutSize: TBctxItemWithoutSize[]) {
    return this.getBctxItemsOrderWithoutSize().pipe(
      take(1),
      map((res) => {
        return BCTXComputationHelper.getUniqueBctxKeyWithOrder(res, bctxItemsWithoutSize);
      }),
    );
  }

  getBulkEventsMetadataAndEventsInfo(
    linkedVIdAndBctxList: { linked_v_id?: string; bctxDetails: TEventBctxDetails }[],
    eventTime: number,
    locaiton: TEventLocation,
  ) {
    return this.getBulkEventMetadata(eventTime, locaiton).pipe(
      take(1),
      map((metadata) => {
        return {
          eventsCommonDetails: this.getEventsCommonDetails(linkedVIdAndBctxList, eventTime),
          metadata,
        };
      }),
    );
  }

  getBctxChangeBulkEvent(
    eventTime: number,
    newBctxItemListWithoutSize: TBctxItemWithoutSize[],
    oldBctxItemListWithoutSize: TBctxItemWithoutSize[],
    sizeInfo: TBctxChangeEventSizeInfo,
  ): Observable<TBctxChangeEventWithoutStatus> {
    const locaiton = oldBctxItemListWithoutSize.length === 0 ? 'ACROSS_BCTX' : 'WITH_IN_BCTX';
    return this.getBulkEventMetadata(eventTime, locaiton).pipe(
      take(1),
      map((metadata) => {
        return {
          type: 'BCTX_CHANGE_EVENT' as TBCTXChangeEventType,
          metadata,
          events: [
            EventUtil.getYetToBeSyncedBctxChangeEventCommonDetails(
              oldBctxItemListWithoutSize,
              newBctxItemListWithoutSize,
              eventTime,
              sizeInfo,
            ),
          ],
        };
      }),
    );
  }

  getMemberAdditionBulkEventsMetadataAndEventsInfo(
    eventTime: number,
    bctxInfo: TSelectedBctxInfo,
    memberAdditionInfo: TMemberAdditionInfo,
  ) {
    return this.getBulkEventMetadata(eventTime, 'WITH_IN_BCTX').pipe(
      take(1),
      map((metadata) => {
        return {
          metadata,
          events: [
            EventUtil.getYetToBeSyncedMemberAdditionEventCommonDetails(
              memberAdditionInfo,
              bctxInfo.bctxInfoWithoutSize.list,
              eventTime,
              bctxInfo.size,
            ),
          ],
        };
      }),
    );
  }

  getRoamingQcBulkEventsWithoutStatus(auditDetails: TAuditDTOModel): Observable<TRoamingQcEventWithoutStatus> {
    const eventTime = new Date().getTime();
    return this.getBulkEventMetadata(eventTime, 'WITH_IN_BCTX').pipe(
      take(1),
      map((metadata) => {
        return {
          type: 'ROAMING_QC_EVENT',
          metadata,
          events: [EventUtil.getYetToBeSyncedRoamingQcEventCommonDetails(auditDetails, eventTime)],
        };
      }),
    );
  }

  getAqlBulkEventsWithoutStatus(aqlSingleDetail: TSingleAuditDetail): Observable<TAqlEventWithoutStatus> {
    const eventTime = new Date().getTime();
    return this.getBulkEventMetadata(eventTime, 'WITH_IN_BCTX').pipe(
      take(1),
      map((metadata) => {
        return {
          type: 'AQL_EVENT',
          metadata,
          events: [EventUtil.getAqlEventCommonDetails(aqlSingleDetail, eventTime)],
        };
      }),
    );
  }

  AcquireLockAndRestoreToBeRectifiedCounts(bctxWithMultipleSizeList: TBctxWithMultipleSize[]) {
    this.store.dispatch(new AcquireLockAndRestoreToBeRectifiedCounts(bctxWithMultipleSizeList));
  }

  getLastFttEventForCurrentLineAndShift() {
    return this.store.pipe(select(getLastFttEventForCurrentLineAndShift));
  }

  getSubjectKey() {
    return this.store.pipe(select(getSubjectKey));
  }

  getPerPieceTagDetails(tagId: string) {
    return this.getSubjectKey().pipe(
      take(1),
      switchMap((subjectKey) => {
        return this.inputAppDataService.getPerPieceTagDetails({ subject_key: subjectKey, displayTag: tagId });
      }),
    );
  }

  getCutbankTagDetails(tagId: string) {
    return this.getSubjectKey().pipe(
      take(1),
      switchMap((subjectKey) => {
        return this.inputAppDataService.getCutBankInCuttag({ subject_key: subjectKey, displayTag: tagId });
      }),
    );
  }

  getRFIDTagDetails(tagIds: string[]) {
    return this.getSubjectKey().pipe(
      take(1),
      switchMap((subjectKey) => {
        return this.inputAppDataService.getRFIDTagDetails({ subjectKey: subjectKey, rfidTagList: tagIds });
      }),
    );
  }

  getUndoValidateInfo() {
    return this.store.pipe(select(getUndoValidateInfo));
  }

  getTransactionWipTypeAndSubjectKeyAndAppIdentifier() {
    return this.store.pipe(select(getTransactionWipTypeAndSubjectKeyAndAppIdentifier));
  }

  reconcileAndSyncWipForBackground(
    moreActions: TLoadBctxMoreActions,
    updateActualsOnly: boolean,
    reconcileIsCompleted: boolean,
  ) {
    if (!reconcileIsCompleted)
      this.store.dispatch(
        new AcquireUserDBLockAndBgDBLockAndReconcile(updateActualsOnly, false, {
          chainWithSyncWipForBackground: moreActions,
        }),
      );
    else {
      this.store.dispatch(new AcquireUserDBLockAndSyncStyleInfo(true, moreActions));
    }
  }

  syncWipForNonCountingApps(hideLoader: boolean) {
    this.store.dispatch(new AcquireUserDBLockAndSyncStyleInfo(hideLoader, { discardWipUpdates: false }));
  }

  loadBctxWithChainActions(moreActions: TLoadBctxMoreActions, chainActions: TLoadBctxSideActions) {
    this.store.dispatch(new AcquireUserDBLockAndSyncStyleInfo(false, moreActions, chainActions));
  }

  fetchIncompleteBundlesAndLoadBctxWithChainActions(
    moreActions: TLoadBctxMoreActions,
    chainActions: TLoadBctxSideActions,
  ) {
    this.store.dispatch(
      new AcquireUserDBLockAndFetchIncompleteBundles({
        chainWithBctxSync: {
          hideLoader: false,
          moreActions,
          chainActions,
        },
      }),
    );
  }

  fetchServerDefectivesAfterSyncingAllPendingEvents(updateActualsOnly: boolean, isBgDBUnlocked: boolean) {
    this.getClientDBAndOnlineStatusAndEventsBatchCountAndCurrentLineAndShift()
      .pipe(take(1))
      .subscribe(({ isOnline, batchCount, userDB, bgDB }) => {
        if (!isOnline)
          this.inputAppErrorDisplayUtil.showPopup(
            this.translate.instant('input_app_common.error'),
            this.translate.instant('input_app_db_facade.noInternet'),
          );
        else if (!isBgDBUnlocked) {
          this.pollForBgDBLock(updateActualsOnly, { chainWithReFetchServerDefectives: true });
        } else if (EventUtil.hasAnyPendingEvents(userDB, bgDB)) {
          this.store.dispatch(
            new AcquireBgDBLockAndThenSyncEvents(updateActualsOnly, true, batchCount, {
              chainWithReFetchServerDefectives: true,
            }),
          );
        } else this.emitLoadServerDefectivesSubscription(false);
      });
  }

  acquireLockAndReSyncFailedEvents(
    events: (TSingleCountEvent | TMemberAdditionSingleEvent)[],
    eventsDayType: TReSyncEventsDayType,
  ) {
    this.getClientDBAndOnlineStatusAndEventsBatchCountAndCurrentLineAndShift()
      .pipe(take(1))
      .subscribe(({ isOnline }) => {
        if (isOnline) {
          if (eventsDayType === 'PAST_DAYS') {
            this.acquireBgDBLock('RE_SYNC_FAILED_EVENTS')
              .pipe(take(1))
              .subscribe((bgDBLockDetails) => {
                if (bgDBLockDetails.status === 'SUCCESS') {
                  this.store.dispatch(
                    new reSyncPastDaysFailedEventsAndThenReleaseBgDBLock(events, eventsDayType, true),
                  );
                } else {
                  this.inputAppErrorDisplayUtil.showPopup(
                    this.translate.instant('input_app_common.error'),
                    bgDBLockDetails.message,
                  );
                }
              });
          } else {
            this.acquireUserAndBgDBLock('RE_SYNC_FAILED_EVENTS')
              .pipe(take(1))
              .subscribe((LockDetails) => {
                if (LockDetails[0].status === 'SUCCESS' && LockDetails[1].status === 'SUCCESS') {
                  this.store.dispatch(
                    new reSyncTodayFailedEventsAndThenReleaseUserAndBgDBLock(events, eventsDayType, true),
                  );
                } else {
                  const message =
                    (LockDetails[0].status === 'FAILURE' ? LockDetails[0].message : '') +
                    (LockDetails[1].status === 'FAILURE' ? LockDetails[1].message : '');
                  this.inputAppErrorDisplayUtil.showPopup(this.translate.instant('input_app_common.error'), message);
                }
              });
          }
        } else {
          this.inputAppErrorDisplayUtil.showPopup(
            this.translate.instant('input_app_common.error'),
            this.translate.instant('input_app_db_facade.noInternet'),
          );
        }
      });
  }

  forceSyncWipAfterSyncingAllPendingEvents(
    updateActualsOnly: boolean,
    isBgDBUnlocked: boolean,
    reconcileIsCompleted: boolean,
  ) {
    this.getClientDBAndOnlineStatusAndEventsBatchCountAndCurrentLineAndShift()
      .pipe(take(1))
      .subscribe(({ isOnline, batchCount, userDB, bgDB }) => {
        if (!isOnline)
          this.inputAppErrorDisplayUtil.showPopup(
            this.translate.instant('input_app_common.error'),
            this.translate.instant('input_app_db_facade.noInternet'),
          );
        else if (!isBgDBUnlocked) {
          this.pollForBgDBLock(updateActualsOnly, { chainWithReFetchWip: true });
        } else if (EventUtil.hasAnyPendingEvents(userDB, bgDB)) {
          this.store.dispatch(
            new AcquireBgDBLockAndThenSyncEvents(updateActualsOnly, true, batchCount, {
              chainWithReFetchWip: true,
            }),
          );
        } else if (!reconcileIsCompleted)
          this.store.dispatch(
            new AcquireUserDBLockAndBgDBLockAndReconcile(updateActualsOnly, true, { chainWithReFetchWip: true }),
          );
        else
          this.store.dispatch(
            new AcquireUserDBLockAndSyncStyleInfo(
              false,
              { discardWipUpdates: updateActualsOnly },
              { chainWithBctxChangeEvent: true },
            ),
          );
      });
  }

  async forceLogoutAfterSyncingAllPendingEventsWrapper(updateActualsOnly: boolean) {
    if (this.lockAction === true) {
      this.inputAppErrorDisplayUtil.showPopup('Warning', 'Please wait previous request is processing...');
      return;
    }
    this.lockAction = true;
    await this.inputAppErrorDisplayUtil.presentLoadingWithId('LOGOUT_ACK_FOR_PENDING_EVENTS_START', 'Loading...');
    this.store
      .pipe(select(getLogoutAckMetadata))
      .pipe(take(1))
      .subscribe((res) => {
        this.inputAppDataService
          .devicePendingEventsSyncStatusBeforeLogoutAck({
            ...res,
            syncStatus: 'START',
          })
          .pipe(take(1))
          .subscribe(
            (res) => {
              this.forceLogoutAfterSyncingAllPendingEvents(updateActualsOnly, false, false);
              this.inputAppErrorDisplayUtil.dismissLoadingWithId('LOGOUT_ACK_FOR_PENDING_EVENTS_START');
              this.lockAction = false;
            },
            (error) => {
              this.forceLogoutAfterSyncingAllPendingEvents(updateActualsOnly, false, false);
              this.inputAppErrorDisplayUtil.dismissLoadingWithId('LOGOUT_ACK_FOR_PENDING_EVENTS_START');
              this.lockAction = false;
            },
          );
      });
  }

  forceLogoutAfterSyncingAllPendingEvents(
    updateActualsOnly: boolean,
    isBgDBUnlocked: boolean,
    reconcileIsCompleted: boolean,
  ) {
    this.getClientDBAndOnlineStatusAndEventsBatchCountAndCurrentLineAndShift()
      .pipe(take(1))
      .subscribe(({ isOnline, batchCount, userDB, bgDB }) => {
        if (!isOnline)
          this.inputAppErrorDisplayUtil.showPopup('Error', 'Not connected to internet, please check the connection');
        else if (!isBgDBUnlocked) {
          this.pollForBgDBLock(updateActualsOnly, { chainWithLogout: true });
        } else if (EventUtil.hasAnyPendingEvents(userDB, bgDB)) {
          this.store.dispatch(
            new AcquireBgDBLockAndThenSyncEvents(updateActualsOnly, true, batchCount, { chainWithLogout: true }),
          );
        } else if (!reconcileIsCompleted)
          this.store.dispatch(
            new AcquireUserDBLockAndBgDBLockAndReconcile(updateActualsOnly, true, { chainWithLogout: true }),
          );
        else this.emitLogoutAppSubscription();
      });
  }

  forcePerPieceLineInUndoAfterSyncingAllPendingEvents(
    updateActualsOnly: boolean,
    dto: TPerPieceLineInUndoDTO,
    isBgDBUnlocked: boolean,
    reconcileIsCompleted: boolean,
  ) {
    this.getClientDBAndOnlineStatusAndEventsBatchCountAndCurrentLineAndShift()
      .pipe(take(1))
      .subscribe(({ isOnline, batchCount, userDB, bgDB, selectedBctxInfo }) => {
        if (!isOnline)
          this.inputAppErrorDisplayUtil.showPopup(
            this.translate.instant('input_app_common.error'),
            this.translate.instant('input_app_db_facade.noInternet'),
          );
        else if (!isBgDBUnlocked) {
          this.pollForBgDBLock(updateActualsOnly, { chainWithPerPieceLineInUndo: dto });
        } else if (EventUtil.hasAnyPendingEvents(userDB, bgDB)) {
          this.store.dispatch(
            new AcquireBgDBLockAndThenSyncEvents(updateActualsOnly, true, batchCount, {
              chainWithPerPieceLineInUndo: dto,
            }),
          );
        } else if (!reconcileIsCompleted)
          this.store.dispatch(
            new AcquireUserDBLockAndBgDBLockAndReconcile(updateActualsOnly, true, { chainWithPerPieceLineInUndo: dto }),
          );
        else
          this.validateUndoBulkEventAndAddEvents(
            dto.bulkEvent,
            dto.eventAdditionMoreActions,
            selectedBctxInfo.bctxInfoWithoutSize.bctxKey === dto.bulkEvent.events[0].eventInfo.bctxDetails.bctxKey
              ? 'WITH_IN_BCTX'
              : 'ACROSS_BCTX',
            dto.poSplitUndoWipOverrideDetails,
          );
      });
  }

  lineChangeForNonCountingApps() {
    this.store.dispatch(
      new AcquireUserDBLockAndSyncStyleInfo(
        false,
        { discardWipUpdates: false },
        { chainWithLoadMasterdataLists: true },
      ),
    );
  }

  forceInitLineChangeAfterSyncingAllPendingEvents(
    updateActualsOnly: boolean,
    isBgDBUnlocked: boolean,
    reconcileIsCompleted: boolean,
    dto: TLineChangeActions,
  ) {
    this.getClientDBAndOnlineStatusAndEventsBatchCountAndCurrentLineAndShift()
      .pipe(take(1))
      .subscribe(({ isOnline, batchCount, userDB, bgDB }) => {
        if (!isOnline)
          this.inputAppErrorDisplayUtil.showPopup(
            this.translate.instant('input_app_common.error'),
            this.translate.instant('input_app_db_facade.noInternet'),
          );
        else if (!isBgDBUnlocked) {
          this.pollForBgDBLock(updateActualsOnly, { chainWithInitForLineChange: dto });
        } else if (EventUtil.hasAnyPendingEvents(userDB, bgDB)) {
          this.store.dispatch(
            new AcquireBgDBLockAndThenSyncEvents(updateActualsOnly, true, batchCount, {
              chainWithInitForLineChange: dto,
            }),
          );
        } else if (!reconcileIsCompleted)
          this.store.dispatch(
            new AcquireUserDBLockAndBgDBLockAndReconcile(updateActualsOnly, true, { chainWithInitForLineChange: dto }),
          );
        else {
          if (dto.isPlanBasedApp) {
            this.store.dispatch(
              new AcquireUserDBLockAndSyncStyleInfoForPlanBased(dto.actions as TLoadBctxSideActionsPlanBased),
            );
          } else {
            this.store.dispatch(
              new AcquireUserDBLockAndSyncStyleInfo(
                false,
                { discardWipUpdates: updateActualsOnly },
                dto.actions as TLoadBctxSideActions,
              ),
            );
          }
        }
      });
  }

  isUndoValidationRequired(actionType: TForwardEventActionType) {
    return this.getUndoValidateInfo().pipe(
      take(1),
      map(({ validationNeeded }) => {
        if (
          (actionType === 'CHECK_IN' || actionType === 'FTT' || actionType === 'REWORKED_FROM_DEFECTIVE') &&
          validationNeeded
        )
          return true;
        else return false;
      }),
    );
  }

  isWeb() {
    return !(this.platform.is('android') || this.platform.is('ios'));
  }

  backgroundSyncEvents(updateActualsOnly: boolean) {
    this.getClientDBAndOnlineStatusAndEventsBatchCountAndCurrentLineAndShift()
      .pipe(take(1))
      .subscribe(({ isOnline, userDB, bgDB, batchCount }) => {
        if (isOnline && EventUtil.hasAnyPendingEvents(userDB, bgDB)) {
          this.store.dispatch(new AcquireBgDBLockAndThenSyncEvents(updateActualsOnly, false, batchCount));
        }
      });
  }

  backgroundSyncEventsJustAfterEventAdditionOrBgSyncing(updateActualsOnly: boolean) {
    this.getConfigurations()
      .pipe(take(1))
      .subscribe(({ syncImmediatelyAfterEventAddition }) => {
        if (syncImmediatelyAfterEventAddition || this.isWeb()) this.backgroundSyncEvents(updateActualsOnly);
      });
  }

  forceUndoEventAfterSyncingAllPendingEvents(
    updateActualsOnly: boolean,
    undoDto: TUndoDTO,
    isBgDBUnlocked: boolean,
    reconcileIsCompleted: boolean,
  ) {
    const { actionType, selectedBctx, undoLimit } = undoDto;
    const hasSelectedBctx = selectedBctx.list.length > 0;
    this.getClientDBAndOnlineStatusAndEventsBatchCountAndCurrentLineAndShift()
      .pipe(
        take(1),
        switchMap(({ selectedStationIdAndShiftId, userDB, bgDB, batchCount, retryCount }) => {
          return this.isUndoValidationRequired(undoDto.actionType).pipe(
            take(1),
            map(
              (validationNeeded) =>
                [validationNeeded, selectedStationIdAndShiftId, userDB, bgDB, batchCount, retryCount] as const,
            ),
          );
        }),
      )
      .subscribe(([validationNeeded, selectedStationIdAndShiftId, userDB, bgDB, batchCount, retryCount]) => {
        if (validationNeeded && !isBgDBUnlocked) this.pollForBgDBLock(updateActualsOnly, { chainWithUndo: undoDto });
        else if (validationNeeded && EventUtil.hasAnyPendingEvents(userDB, bgDB)) {
          this.store.dispatch(
            new AcquireBgDBLockAndThenSyncEvents(updateActualsOnly, true, batchCount, {
              chainWithUndo: undoDto,
            }),
          );
        } else if (validationNeeded && !reconcileIsCompleted)
          this.store.dispatch(
            new AcquireUserDBLockAndBgDBLockAndReconcile(updateActualsOnly, true, { chainWithUndo: undoDto }),
          );
        else {
          const { shiftId, stationId } = selectedStationIdAndShiftId;
          const lastEventResult = EventUtil.getLastEventWithLimitWithModifiedVId(
            BCTXComputationHelper.getBulkEventsWithStatus(
              userDB.dailyCache.events.list,
              bgDB.dailyCache.events.list,
              retryCount,
              bgDB.persistanceCache.nextEventId,
            )[0],
            stationId,
            shiftId,
            actionType,
            undoLimit,
            hasSelectedBctx ? selectedBctx.bctxKey : null,
          );
          if (lastEventResult.status === 'FAILURE') {
            this.inputAppErrorDisplayUtil.showPopup(
              this.translate.instant('input_app_common.error'),
              this.translate.instant(UNDO_ERROR_TO_DISPLAY_MESSAGE[lastEventResult.error]),
            );
          } else {
            this.validateUndoBulkEventAndAddEvents(
              lastEventResult.event,
              { updateActualsOnly },
              hasSelectedBctx ? 'WITH_IN_BCTX' : 'ACROSS_BCTX',
            );
          }
        }
      });
  }

  forcePerPieceQcUndoEventAfterSyncingAllPendingEvents(
    updateActualsOnly: boolean,
    undoDto: TPerPieceQcUntoDTO,
    isBgDBUnlocked: boolean,
    reconcileIsCompleted: boolean,
  ) {
    const { actionType, undoLimit } = undoDto;
    this.getClientDBAndOnlineStatusAndEventsBatchCountAndCurrentLineAndShift()
      .pipe(
        take(1),
        switchMap(({ selectedStationIdAndShiftId, userDB, bgDB, batchCount, retryCount }) => {
          return this.isUndoValidationRequired(undoDto.actionType).pipe(
            take(1),
            map(
              (validationNeeded) =>
                [validationNeeded, selectedStationIdAndShiftId, userDB, bgDB, batchCount, retryCount] as const,
            ),
          );
        }),
      )
      .subscribe(([validationNeeded, selectedStationIdAndShiftId, userDB, bgDB, batchCount, retryCount]) => {
        if (validationNeeded && !isBgDBUnlocked)
          this.pollForBgDBLock(updateActualsOnly, { chainWithPerPieceQcUndo: undoDto });
        else if (validationNeeded && EventUtil.hasAnyPendingEvents(userDB, bgDB)) {
          this.store.dispatch(
            new AcquireBgDBLockAndThenSyncEvents(updateActualsOnly, true, batchCount, {
              chainWithPerPieceQcUndo: undoDto,
            }),
          );
        } else if (validationNeeded && !reconcileIsCompleted)
          this.store.dispatch(
            new AcquireUserDBLockAndBgDBLockAndReconcile(updateActualsOnly, true, { chainWithPerPieceQcUndo: undoDto }),
          );
        else {
          const { shiftId, stationId } = selectedStationIdAndShiftId;
          const lastEventResult = EventUtil.getPerPieceQcLastEventWithLimitWithModifiedVId(
            BCTXComputationHelper.getBulkEventsWithStatus(
              userDB.dailyCache.events.list,
              bgDB.dailyCache.events.list,
              retryCount,
              bgDB.persistanceCache.nextEventId,
            )[0],
            stationId,
            shiftId,
            actionType,
            undoLimit,
            undoDto.serverDefectivesDataUndo,
          );
          if (lastEventResult.status === 'FAILURE') {
            this.inputAppErrorDisplayUtil.showPopup(
              this.translate.instant('input_app_common.error'),
              this.translate.instant(UNDO_ERROR_TO_DISPLAY_MESSAGE[lastEventResult.error]),
            );
          } else {
            this.validateUndoBulkEventAndAddEvents(
              lastEventResult.event,
              undoDto.eventAdditionMoreActions,
              'ACROSS_BCTX',
            );
          }
        }
      });
  }

  validateUndoBulkEventAndAddEvents(
    bulkEvent: TForwardBulkEvent,
    eventAdditionMoreActions: TEventAddtionMoreActions,
    location: TEventLocation,
    poSplitUndoWipOverrideDetails?: TBctxItem[],
  ) {
    return this.store.dispatch(
      new AcquireUserDBLockAndValidateUndoBulkEventAndAddEvents(
        bulkEvent,
        eventAdditionMoreActions,
        location,
        poSplitUndoWipOverrideDetails,
      ),
    );
  }

  addTeamMembers(updateActualsOnly: boolean, memberAdditionInfo: TMemberAdditionInfo, selectedBctx: TSelectedBctxInfo) {
    const eventTime = new Date().getTime();
    this.getMemberAdditionBulkEventsMetadataAndEventsInfo(eventTime, selectedBctx, memberAdditionInfo)
      .pipe(take(1))
      .subscribe((res) => {
        this.acquireLockAndThenAddBulkEvents(
          [
            {
              metadata: res.metadata,
              events: res.events,
              type: 'MEMBER_ADDITION_EVENT',
            },
          ],
          false,
          { updateActualsOnly: updateActualsOnly },
        );
      });
  }

  getRecentDefects() {
    return this.store.pipe(select(getRecentDefects));
  }

  getRecentDefectsV2() {
    return this.store.pipe(select(getRecentDefectsV2));
  }

  getMemberAdditionViewDescriptor() {
    return this.store.pipe(select(getMemberAdditionViewDescriptor));
  }

  getMemberAdditionViewDescriptorAndAddedList() {
    return this.store.pipe(select(getMemberAdditionViewDescriptorAndAddedList));
  }

  getSimpleGradingPageViewDescriptor() {
    return this.store.pipe(select(getSimpleGradingPageViewDescriptor));
  }

  getSimpleLineInGradingPageViewDescriptor() {
    return this.store.pipe(select(getSimpleLineInGradingPageViewDescriptor));
  }

  getMemberAdditionList() {
    return this.store.pipe(select(getMemberAdditionList));
  }

  getWipCount(sizeName: string, bctxKey: string) {
    return this.getMergedLineMapAndSelectedStationIdAndShiftId().pipe(
      take(1),
      map(({ mergedLineMap, selectedStationIdAndShiftId }) => {
        return mergedLineMap[selectedStationIdAndShiftId.stationId].bctxWipMap[bctxKey].sizeToWipMap[sizeName].wip_qty;
      }),
    );
  }

  getFttOrCheckInBulkEvent(
    eventTime: number,
    sizeName: string,
    selectedBctx: TBctxItemWithoutSizeAndBctxKey,
    count: number,
    isCheckIn: boolean,
    linked_v_id?: string,
    selectedBxtxWithNewDetails?: TSelectedBctxInfo,
  ) {
    return this.getBulkEventsMetadataAndEventsInfo(
      [
        {
          bctxDetails: {
            businessContextDetailsWithoutSize: selectedBctx.list,
            bctxKey: selectedBctx.bctxKey,
            count: count,
            size: sizeName,
            ...(selectedBxtxWithNewDetails?.newBctxForPOSplit && {
              newBctxDetails: {
                bctxKey: selectedBxtxWithNewDetails.newBctxForPOSplit.bctx.bctxKey,
                businessContextDetailsWithoutSize: selectedBxtxWithNewDetails.newBctxForPOSplit.bctx.list,
                groupedHeaderInfo: selectedBxtxWithNewDetails.newBctxForPOSplit.groupedHeaderInfo,
              },
            }),
          },
          linked_v_id: linked_v_id,
        },
      ],
      eventTime,
      'WITH_IN_BCTX',
    ).pipe(
      take(1),
      map(({ metadata, eventsCommonDetails }) => {
        const event: TBulkEventWithoutStatus = {
          type: 'FORWARD_BULK_EVENT',
          metadata,
          events: eventsCommonDetails.map((eventCommonDetails, index) => {
            return {
              type: 'FORWARD_EVENT',
              actionType: isCheckIn ? 'CHECK_IN' : 'FTT',
              eventInfo: eventCommonDetails,
            };
          }),
        };
        return event;
      }),
    );
  }

  addFtt(
    sizeName: string,
    selectedBctx: TBctxItemWithoutSizeAndBctxKey,
    count: number,
    moreActions: TEventAddtionMoreActions,
    sideActions?: TEventAddtionSideActions,
  ) {
    const eventTime = new Date().getTime();
    this.getFttOrCheckInBulkEvent(eventTime, sizeName, selectedBctx, count, false).subscribe((res) => {
      this.acquireLockAndThenAddBulkEvents([res], false, moreActions, sideActions);
    });
  }

  addCheckin(
    sizeName: string,
    selectedBctx: TBctxItemWithoutSizeAndBctxKey,
    count: number,
    moreActions: TEventAddtionMoreActions,
    sideActions?: TEventAddtionSideActions,
  ) {
    const eventTime = new Date().getTime();
    this.getFttOrCheckInBulkEvent(eventTime, sizeName, selectedBctx, count, true).subscribe((res) => {
      this.acquireLockAndThenAddBulkEvents([res], false, moreActions, sideActions);
    });
  }

  hasIncompleteBundlesInfoInitializedForCurrentStationAndShift() {
    return this.store.pipe(select(hasIncompleteBundlesInfoInitializedForCurrentStationAndShift));
  }

  addMissingEventsStatusInBgDB(
    userDBEvents: TBulkEventWithoutStatus[],
    bgDB: TBackgroundEventsSyncingDB,
    isOnline: boolean,
  ) {
    return this.getConfigurations().pipe(
      take(1),
      switchMap(({ retryCount }) => {
        const [bulkEvents, newNextEventId] = BCTXComputationHelper.getBulkEventsWithStatus(
          userDBEvents,
          bgDB.dailyCache.events.list,
          retryCount,
          bgDB.persistanceCache.nextEventId,
        );
        bgDB = produce(bgDB, (draft) => {
          if (!isOnline) draft.dailyCache.events.list = BCTXComputationHelper.getStatusInfoFromBulkEvents(bulkEvents);
          draft.persistanceCache.nextEventId = newNextEventId;
        });
        return from(this.persistanceStorageService.set('[APP][INPUT_APP_BACKGROUND_EVENTS_SYNCING_DB]', bgDB)).pipe(
          take(1),
          map(() => {
            this.store.dispatch(new UpdateBgDB(bgDB));
            return [bgDB, bulkEvents] as const;
          }),
        );
      }),
    );
  }

  handleInputAppBackupDBforPastDayEventsUpdate(bulkEvents: TBulkEvent[]): Observable<boolean> {
    return this.getPastDaySyncedEventsDB().pipe(
      take(1),
      switchMap((inputAppBackupDB) => {
        inputAppBackupDB = inputAppBackupDB || { listOfPastDaysEventsWhichAreSynced: [] };
        const eventsToPush = bulkEvents.filter((event) => {
          return (
            (event.type === 'FORWARD_BULK_EVENT' ||
              event.type === 'UNDO_BULK_EVENT' ||
              event.type === 'MEMBER_ADDITION_EVENT') &&
            event.backgroundMetadata.bulkEventStatus !== 'SYNCED'
          );
        }) as TActivityLogEvent[];
        inputAppBackupDB = produce(inputAppBackupDB, (draft) => {
          draft.listOfPastDaysEventsWhichAreSynced.push(...eventsToPush);
        });
        return this.setPastDaySyncedEventsDB(inputAppBackupDB).pipe(map(() => true));
      }),
    );
  }

  handleInputAppBackupDBforPastDayEventsatDailyCacheReset(
    bulkEvents: TBulkEvent[],
    delayedEventsSLAInDays: number,
    cacheResetTimestampInMilliSeconds: number,
  ): Observable<boolean> {
    return this.getPastDaySyncedEventsDB().pipe(
      take(1),
      switchMap((inputAppBackupDB) => {
        inputAppBackupDB = inputAppBackupDB || { listOfPastDaysEventsWhichAreSynced: [] };
        const bulkEventsToPush = bulkEvents.filter((event) => {
          return (
            (event.type === 'FORWARD_BULK_EVENT' ||
              event.type === 'UNDO_BULK_EVENT' ||
              event.type === 'MEMBER_ADDITION_EVENT') &&
            event.backgroundMetadata.bulkEventStatus !== 'YET_TO_BE_SYNCED' &&
            event.backgroundMetadata.bulkEventStatus !== 'SYNCED'
          );
        }) as TActivityLogEvent[];
        const nonDelayedBackupEvents = EventUtil.getNonDelayedEvents(
          delayedEventsSLAInDays,
          inputAppBackupDB.listOfPastDaysEventsWhichAreSynced,
          cacheResetTimestampInMilliSeconds,
        ) as TActivityLogEvent[];
        const updatedEvents = [...nonDelayedBackupEvents, ...bulkEventsToPush];
        inputAppBackupDB = produce(inputAppBackupDB, (draft) => {
          draft.listOfPastDaysEventsWhichAreSynced = updatedEvents;
        });
        return this.setPastDaySyncedEventsDB(inputAppBackupDB).pipe(map(() => true));
      }),
    );
  }

  reconcileUserAndBgEventsDB(
    userDB: TUserActualsDB,
    bgDB: TBackgroundEventsSyncingDB,
    nextCacheResetTimestamp: number,
  ) {
    return this.getAppIdentifier().pipe(
      take(1),
      switchMap((appIdentifier) => {
        return this.getConfigurations().pipe(
          take(1),
          map(
            ({
              retryCount,
              delayedEventsSLAInDays,
              cacheResetTimestampInMilliSeconds,
              delayWipUpdatesByMin,
              aggregatedLineMapForPerPiece,
              pastDaysEventsStorePerPieceEnabled,
              enableTabDataCapture,
            }) => {
              let itIsCacheResetTime: boolean = false;

              if (userDB.dailyCache.nextCacheResetTimestamp !== bgDB.dailyCache.nextCacheResetTimestamp) {
                this.customLoggerService.log('RECONCILE_NCRT_MISMATCH', {
                  targetNCRT: nextCacheResetTimestamp,
                  userDBNCRT: userDB.dailyCache.nextCacheResetTimestamp,
                  bgDBNCRT: bgDB.dailyCache.nextCacheResetTimestamp,
                  userDBEventsCount: userDB.dailyCache.events.list.length,
                  bgDBEventsCount: bgDB.dailyCache.events.list.length,
                });
              }
              const [bulkEvents, newNextEventId] = BCTXComputationHelper.getBulkEventsWithStatus(
                userDB.dailyCache.events.list,
                bgDB.dailyCache.events.list,
                retryCount,
                bgDB.persistanceCache.nextEventId,
              );

              const oldUserDBLineMap = cloneDeep(userDB.dailyCache.lineMap);
              const oldBgDBLineMap = cloneDeep(bgDB.dailyCache.lineMap);
              let mergedLineMap = userDB.dailyCache.lineMap;
              let mergedPpLineMap = userDB.dailyCache.ppLineMap;
              if (aggregatedLineMapForPerPiece && BCTXComputationHelper.isPerPieceApp(appIdentifier)) {
                mergedPpLineMap = PerPieceComputationHelper.mergeUserAggregatedLineMapWithBgAggregatedLineMap(
                  userDB.dailyCache.ppLineMap,
                  bgDB.dailyCache.ppLineMap,
                );
              } else {
                mergedLineMap = BCTXComputationHelper.mergeUserLineMapWithBgLineMap(
                  userDB.dailyCache.lineMap,
                  bgDB.dailyCache.lineMap,
                );
              }

              const initialState = getInputAppInitialState(nextCacheResetTimestamp);
              if (userDB.dailyCache.nextCacheResetTimestamp === nextCacheResetTimestamp) {
                userDB = produce(userDB, (draft) => {
                  draft.dailyCache.ppLineMap = mergedPpLineMap;
                  draft.dailyCache.lineMap = mergedLineMap;
                });
              } else {
                userDB = produce(initialState.userDB, (draft) => {
                  draft.dailyCache.lineMap = BCTXComputationHelper.reconcileWipAndActualsFromPastdays(
                    mergedLineMap,
                    appIdentifier === 'bundle_qc_v2' ? userDB.persistanceCache.incompleteBundlesInfo : undefined,
                  );
                  draft.persistanceCache = userDB.persistanceCache;
                });
              }
              if (bgDB.dailyCache.nextCacheResetTimestamp === nextCacheResetTimestamp) {
                bgDB = produce(bgDB, (draft) => {
                  draft.dailyCache.lineMap = {};
                  draft.dailyCache.ppLineMap = {};
                  draft.persistanceCache.nextEventId = newNextEventId;
                  draft.dailyCache.events.list = BCTXComputationHelper.getStatusInfoFromBulkEvents(bulkEvents);
                });
              } else {
                //To identify if it is cache reset time
                itIsCacheResetTime = true;

                //Resetting daily cache
                bgDB = produce(initialState.bgDB, (draft) => {
                  draft.persistanceCache = bgDB.persistanceCache;
                });

                bgDB = produce(bgDB, (draft) => {
                  draft.persistanceCache.nextEventId = newNextEventId;
                });

                //Updating the pastDaysList in bgDB with pending events from Yesterday and then filtering out based on delayedEventsSLAInDays
                const totalPasyDayEvents = [...bgDB.persistanceCache.pastDaysList, ...bulkEvents].filter(
                  (bulkEvent) => bulkEvent.backgroundMetadata.bulkEventStatus === 'YET_TO_BE_SYNCED',
                );
                const updatedPastEvents = EventUtil.getNonDelayedEvents(
                  delayedEventsSLAInDays,
                  totalPasyDayEvents,
                  cacheResetTimestampInMilliSeconds,
                );
                this.customLoggerService.log('INPUT_APP_CLIENT_DB_FACADE', 'reconcile pastDaysList computed', {
                  candidatesCount: totalPasyDayEvents.length,
                  carriedFromPriorPastDays: bgDB.persistanceCache.pastDaysList.length,
                  newlyDemotedFromToday: totalPasyDayEvents.length - bgDB.persistanceCache.pastDaysList.length,
                  updatedPastEvents: updatedPastEvents,
                });
                bgDB = produce(bgDB, (draft) => {
                  draft.persistanceCache.pastDaysList = updatedPastEvents;
                });

                // Removing events from pastDaysBackgroundEventsSyncInfo
                if (bgDB.persistanceCache.pastDaysBackgroundEventsSyncInfo && delayWipUpdatesByMin) {
                  const updatedPastDaysBackgroundEventsSyncInfo = EventUtil.getEventsWithinDelayWipUpdatesRange(
                    bgDB.persistanceCache.pastDaysBackgroundEventsSyncInfo,
                    delayWipUpdatesByMin,
                  );
                  bgDB = produce(bgDB, (draft) => {
                    draft.persistanceCache.pastDaysBackgroundEventsSyncInfo = updatedPastDaysBackgroundEventsSyncInfo;
                  });
                }

                //Updating defectives statues
                if (appIdentifier === 'endline_qc_v2' || appIdentifier === 'bundle_qc_v2') {
                  const updatedPastDaysDefectives = this.updatePastDaysDefectives(
                    bulkEvents,
                    bgDB.persistanceCache.bulkQcPastDaysDefectives,
                    delayedEventsSLAInDays,
                    cacheResetTimestampInMilliSeconds,
                  );
                  bgDB = produce(bgDB, (draft) => {
                    draft.persistanceCache.bulkQcPastDaysDefectives = updatedPastDaysDefectives;
                  });
                }
              }
              if (enableTabDataCapture) {
                this.customLoggerService.sendDirectLogsToBackend('RECONCILE_DATA_MONITOR', {
                  oldUserDBLineMap,
                  newUserDBLineMap: userDB.dailyCache.lineMap,
                  oldBgDBLineMap,
                  newBgDBLineMap: bgDB.dailyCache.lineMap,
                });
              }
              return [
                userDB,
                bgDB,
                pastDaysEventsStorePerPieceEnabled,
                bulkEvents,
                delayedEventsSLAInDays,
                cacheResetTimestampInMilliSeconds,
                itIsCacheResetTime,
              ] as const;
            },
          ),
          switchMap(
            ([
              userDB,
              bgDB,
              isPastDaysEventsStorePerPieceEnabled,
              bulkEvents,
              delayedEventsSLAInDays,
              cacheResetTimestampInMilliSeconds,
              itIsCacheResetTime,
            ]) => {
              if (itIsCacheResetTime && isPastDaysEventsStorePerPieceEnabled) {
                return this.handleInputAppBackupDBforPastDayEventsatDailyCacheReset(
                  bulkEvents,
                  delayedEventsSLAInDays,
                  cacheResetTimestampInMilliSeconds,
                ).pipe(
                  map((isUpdated) => {
                    if (isUpdated) {
                      console.log('BackupDB updated successfully with events at cache reset');
                    }
                    return [userDB, bgDB] as const;
                  }),
                );
              }
              return of([userDB, bgDB] as const);
            },
          ),
        );
      }),
    );
  }

  updatePastDaysDefectives(
    bulkEvents: TBulkEvent[],
    pastDaysDefectives: TBackgroundEventsSyncingDB['persistanceCache']['bulkQcPastDaysDefectives'],
    delayedEventsSLAInDays: number,
    cacheResetTimestampInMilliSeconds: number,
  ) {
    //Clearing all the past days defectives having a entry for today's defectives
    let updatedPastDaysDefectives = produce(pastDaysDefectives, (draft) => {
      bulkEvents.forEach((bulkEvent) => {
        bulkEvent.events.forEach((event) => {
          if (
            event.actionType === 'DEFECTIVE' ||
            event.actionType === 'UNDO_DEFECTIVE' ||
            event.actionType === 'REJECTED_FROM_DEFECTIVE' ||
            event.actionType === 'UNDO_REJECTED_FROM_DEFECTIVE' ||
            event.actionType === 'REWORKED_FROM_DEFECTIVE' ||
            event.actionType === 'UNDO_REWORKED_FROM_DEFECTIVE'
          ) {
            delete draft[event.defectivesInfo.id];
          }
        });
      });
    });
    bulkEvents.forEach((bulkEvent) => {
      bulkEvent.events.forEach((event) => {
        if (
          event.actionType === 'DEFECTIVE' ||
          event.actionType === 'UNDO_DEFECTIVE' ||
          event.actionType === 'REJECTED_FROM_DEFECTIVE' ||
          event.actionType === 'UNDO_REJECTED_FROM_DEFECTIVE' ||
          event.actionType === 'REWORKED_FROM_DEFECTIVE' ||
          event.actionType === 'UNDO_REWORKED_FROM_DEFECTIVE'
        ) {
          updatedPastDaysDefectives = produce(updatedPastDaysDefectives, (draft) => {
            if (!draft[event.defectivesInfo.id]) {
              draft[event.defectivesInfo.id] = [];
            }
          });
          updatedPastDaysDefectives = produce(updatedPastDaysDefectives, (draft) => {
            draft[event.defectivesInfo.id].push({
              v_id: event.eventInfo.v_id,
              status: event.eventBackgroundMetadata.status,
              eventType: event.actionType,
              eventTime: event.eventInfo.eventTime,
              round: event.defectivesInfo.round,
              syncedTime: bulkEvent.backgroundMetadata.syncedTime,
            });
          });
        }
      });
    });
    return EventUtil.flushBulkQcPastDaysDefectivesInfo(
      updatedPastDaysDefectives,
      delayedEventsSLAInDays,
      cacheResetTimestampInMilliSeconds,
    );
  }

  getLastPerPieceLineInEventDetails(bctxSearchId: string): Observable<TLastEventDetails> {
    return this.getEventsArray().pipe(
      take(1),
      map((res) => {
        const filteredEvents: TBulkCountEvent[] = res.filter((bulkEvent) => {
          if (bulkEvent.events[0].actionType === 'CHECK_IN' || bulkEvent.events[0].actionType === 'UNDO_CHECK_IN') {
            const bctxSearchIdEvent = (
              bulkEvent.events[0].eventInfo as TEventCommonDetails
            ).bctxDetails.businessContextDetailsWithoutSize.find((x) => x.k === 'search_id');
            return bctxSearchIdEvent?.v === bctxSearchId;
          } else {
            return false;
          }
        }) as TBulkCountEvent[];
        const failedEvents = new Set<string>();
        let hasServerError = false;
        filteredEvents.forEach((event) => {
          if (
            (event.events[0].eventInfo.linked_v_id && failedEvents.has(event.events[0].eventInfo.linked_v_id)) ||
            event.events[0].eventBackgroundMetadata.status === 'VALIDATION_ERROR'
          ) {
            failedEvents.add(event.events[0].eventInfo.v_id);
          }
          if (event.events[0].eventBackgroundMetadata.status === 'SERVER_ERROR') hasServerError = true;
        });
        const validEvents = filteredEvents.filter((event) => {
          return !failedEvents.has(event.events[0].eventInfo.v_id);
        });
        if (hasServerError) {
          return {
            hasServerError,
            remainingEvent: {
              event: null,
              modified_v_id: undefined,
            },
            firstEvent: null,
          };
        }
        if (validEvents.length === 0) {
          return {
            hasServerError: false,
            remainingEvent: {
              event: null,
              modified_v_id: undefined,
            },
            firstEvent: null,
          };
        } else {
          const stack = new StackUtil<TBulkCountEvent>();
          validEvents.forEach((event) => {
            stack.push(event);
          });
          while (!stack.isEmpty()) {
            const top = stack.peek();
            if (top.events[0].actionType === 'UNDO_CHECK_IN' && stack.size() > 1) {
              stack.pop();
              stack.pop();
            } else break;
          }
          if (!stack.isEmpty()) {
            return {
              hasServerError: false,
              remainingEvent: {
                event: stack.peek(),
                modified_v_id: validEvents[validEvents.length - 1].events[0].eventInfo.v_id,
              },
              firstEvent: validEvents[0],
            };
          } else {
            return {
              hasServerError: false,
              remainingEvent: {
                event: null,
                modified_v_id: validEvents[validEvents.length - 1].events[0].eventInfo.v_id,
              },
              firstEvent: validEvents[0],
            };
          }
        }
      }),
    );
  }

  getLastLineInEventDetails(
    bctxKey: string,
    filterKeysWithSizeAndDatetime: TBCTXKeysWithDateTime[],
  ): Observable<TLastEventDetails> {
    return this.getEventsArray().pipe(
      take(1),
      map((res) => {
        const filteredEvents: TBulkCountEvent[] = res.filter((bulkEvent) => {
          if (bulkEvent.events[0].actionType === 'CHECK_IN' || bulkEvent.events[0].actionType === 'UNDO_CHECK_IN') {
            const eventInfo = bulkEvent.events[0].eventInfo;
            const bctxItems: TBctxItem[] = [
              ...eventInfo.bctxDetails.businessContextDetailsWithoutSize,
              { k: 'size', v: eventInfo.bctxDetails.size },
              ...(bulkEvent.events[0].actionType === 'CHECK_IN'
                ? [{ k: 'datetime', v: eventInfo.eventTime }]
                : [{ k: 'datetime', v: bulkEvent.events[0].undoMetadata.forwardEventTime }]),
            ] as TBctxItem[];
            const bctxKeyWithSizeDateTime = BCTXComputationHelper.getUniqueBctxKeyWithOrder(
              filterKeysWithSizeAndDatetime,
              bctxItems,
            );
            return bctxKeyWithSizeDateTime === bctxKey;
          }
          return false;
        }) as TBulkCountEvent[];
        const failedEvents = new Set<string>();
        let hasServerError = false;
        filteredEvents.forEach((event) => {
          if (
            (event.events[0].eventInfo.linked_v_id && failedEvents.has(event.events[0].eventInfo.linked_v_id)) ||
            event.events[0].eventBackgroundMetadata.status === 'VALIDATION_ERROR'
          ) {
            failedEvents.add(event.events[0].eventInfo.v_id);
          }
          if (event.events[0].eventBackgroundMetadata.status === 'SERVER_ERROR') hasServerError = true;
        });
        const validEvents = filteredEvents.filter((event) => {
          return !failedEvents.has(event.events[0].eventInfo.v_id);
        });
        if (hasServerError) {
          return {
            hasServerError,
            remainingEvent: {
              event: null,
              modified_v_id: undefined,
            },
            firstEvent: null,
          };
        }
        if (validEvents.length === 0) {
          return {
            hasServerError: false,
            remainingEvent: {
              event: null,
              modified_v_id: undefined,
            },
            firstEvent: null,
          };
        } else {
          const stack = new StackUtil<TBulkCountEvent>();
          validEvents.forEach((event) => {
            stack.push(event);
          });
          while (!stack.isEmpty()) {
            const top = stack.peek();
            if (top.events[0].actionType === 'UNDO_CHECK_IN' && stack.size() > 1) {
              stack.pop();
              stack.pop();
            } else break;
          }
          if (!stack.isEmpty()) {
            return {
              hasServerError: false,
              remainingEvent: {
                event: stack.peek(),
                modified_v_id: validEvents[validEvents.length - 1].events[0].eventInfo.v_id,
              },
              firstEvent: validEvents[0],
            };
          } else {
            return {
              hasServerError: false,
              remainingEvent: {
                event: null,
                modified_v_id: validEvents[validEvents.length - 1].events[0].eventInfo.v_id,
              },
              firstEvent: validEvents[0],
            };
          }
        }
      }),
    );
  }

  getQCLandingViewDescriptor() {
    return this.store.pipe(select(getQCLandingViewDescriptor));
  }

  getWashingLandingViewDescriptor() {
    return this.store.pipe(select(getWashingLandingViewDescriptor));
  }

  getAllKvArray(decodedQrData: Record<string, string>, app_identifier?: TAppIdentifier) {
    return (
      app_identifier && (app_identifier === 'per_piece_washing_in_v2' || app_identifier === 'per_piece_washing_out_v2')
        ? this.getWashingLandingViewDescriptor()
        : this.getQCLandingViewDescriptor()
    ).pipe(
      take(1),
      map((res) => {
        const infoData = this.#mapScannerResult(decodedQrData, res?.scanner_conf);
        const kvArray: TBctxItem[] = [];
        if (infoData) {
          Object.keys(infoData).forEach((item) => {
            const obj: TBctxItem = {
              k: item as TBCTXKeys,
              v: infoData[item] as string,
            };
            kvArray.push(obj);
          });
        }
        return kvArray;
      }),
    );
  }

  decodeAndDoValidationsForTag(byteString: string, doExtraValidations: boolean, app_identifier?: TAppIdentifier) {
    return this.getBctxViz().pipe(
      take(1),
      switchMap((bctxViz: BctxViz[]) => {
        const formattedTagData = this.scannerDataFormatter.decodeTagString(byteString);
        if (formattedTagData.status) {
          return this.getAllKvArray(formattedTagData.data, app_identifier).pipe(
            map((res) => {
              if (res.length > 0) {
                if (doExtraValidations) {
                  for (const item of bctxViz) {
                    if (!item.k) {
                      this.#showTagScanError();
                      return { status: false, result: [], tagType: '' };
                    } else {
                      const bctxItem = res.find((bctxItem) => bctxItem.k === item.k);
                      if (!bctxItem || !bctxItem.v) {
                        this.#showTagScanError();
                        return { status: false, result: [], tagType: '' };
                      }
                    }
                  }
                }
                let tagType: string = '';
                for (const item of bctxViz) {
                  const bctxItem = res.find((bctxItem) => bctxItem.k === item.k);
                  if (bctxItem && bctxItem.v && item.k === 'search_id') {
                    tagType = this.getTagType(bctxItem.v.charAt(0));
                  }
                }
                return { status: true, result: res, tagType: tagType };
              } else {
                this.inputAppErrorDisplayUtil.showPopup(
                  this.translate.instant('common.tagMappingError.header'),
                  this.translate.instant('common.tagMappingError.message'),
                );
                return { status: false, result: [], tagType: '' };
              }
            }),
          );
        } else {
          this.inputAppErrorDisplayUtil.showPopup(
            formattedTagData.errorTitle ? formattedTagData.errorTitle : this.translate.instant('common.error'),
            formattedTagData.error ? formattedTagData.error : this.translate.instant('common.scanError'),
          );
          return of({ status: false, result: [], tagType: '' });
        }
      }),
    );
  }

  private getTagType(firstChar: string): string {
    switch (firstChar) {
      case '1':
        return 'BUNDLE';
      case '2':
        return 'PER_PIECE';
      case '3':
        return 'COMPONENT_BUNDLE';
      default:
        return '';
    }
  }

  #showTagScanError() {
    this.inputAppErrorDisplayUtil.showPopup(
      this.translate.instant('common.error'),
      this.translate.instant('common.scanError'),
    );
  }

  #mapScannerResult(sData: Record<string, string>, config: IQCLanding['scanner_conf']) {
    const infoData: Record<string, string | number> = {};
    if (config) {
      const dataMapping = config.tag_mappings.info_mappings ? config.tag_mappings.info_mappings : [];
      dataMapping.forEach((map) => {
        if (map.type === 'number') {
          infoData[map.info_key] = parseInt(sData[map.tag_key]);
        } else {
          infoData[map.info_key] = sData[map.tag_key];
        }
      });
    }
    return infoData;
  }

  getPerPieceLineInTransactionsPayloadMetadata() {
    return this.store.pipe(select(getPerPieceLineInTransactionsPayloadMetadata));
  }

  getPerPieceLineInTransactions() {
    return this.store.pipe(select(getPerPieceLineInTransactions));
  }

  getPerPieceLineInTransactionsPayload(start: number, end: number) {
    return this.getPerPieceLineInTransactionsPayloadMetadata().pipe(
      take(1),
      map((metadata) => {
        let runningStart = new Date(start).setHours(0, 0, 0, 0);
        const newEnd = new Date(end).setHours(23, 59, 59, 999);
        const dates: string[] = [];
        while (runningStart <= newEnd) {
          dates.push(moment(runningStart).format('YYYY-MM-DD'));
          runningStart = runningStart + 86400000;
        }
        const startDate = moment(start).startOf('day'); // local 00:00
        const endDate = moment(end).endOf('day');

        return {
          ...metadata,
          dates,
          window: startDate.format('YYYY-MM-DDT00:00:00.000[Z]') + '/' + endDate.format('YYYY-MM-DDT23:59:59.999[Z]'),
        };
      }),
    );
  }

  fetchPerPieceLineInTransactions(startTime: number, endTime: number) {
    this.store.dispatch(new ClearAndReFetchPerPieceLineInTransactions(startTime, endTime));
  }

  clearPerPieceLineInTransactions() {
    this.store.dispatch(new ClearPerPieceLineInTransactions());
  }

  getIncompleteBundlesInfoForCurrentStationAndShift() {
    return this.store.pipe(select(getIncompleteBundlesInfoForCurrentStationAndShift));
  }

  getIncompleteBundlesInfoForCustomLineAndShift(stationId: string, shiftId: string) {
    return this.store.pipe(select(getAllLinesIncompleteBundlesInfo)).pipe(
      take(1),
      map((incompleteBundlesInfo) => {
        if (incompleteBundlesInfo[stationId] && incompleteBundlesInfo[stationId][shiftId]) {
          return incompleteBundlesInfo[stationId][shiftId];
        } else return DEFAULT_LINE_SHIFT_INCOMPLETE_BUNDLE_INFO;
      }),
    );
  }

  async sendAllPendingEventsSyncedBeforeLogoutAckAndThenLogout() {
    if (this.lockAction === true) {
      this.inputAppErrorDisplayUtil.showPopup('Warning', 'Please wait previous request is processing...');
      return;
    }
    this.lockAction = true;
    await this.inputAppErrorDisplayUtil.presentLoadingWithId('LOGOUT_ACK_FOR_PENDING_EVENTS_END', 'Loading...');
    this.store
      .pipe(select(getLogoutAckMetadata))
      .pipe(take(1))
      .subscribe((res) => {
        this.inputAppDataService
          .devicePendingEventsSyncStatusBeforeLogoutAck({
            ...res,
            syncStatus: 'END',
          })
          .pipe(take(1))
          .subscribe(
            (res) => {
              console.log(res);
              this.authService.logout();
              this.inputAppErrorDisplayUtil.dismissLoadingWithId('LOGOUT_ACK_FOR_PENDING_EVENTS_END');
              this.lockAction = false;
            },
            (error) => {
              console.log(error);
              this.authService.logout();
              this.inputAppErrorDisplayUtil.dismissLoadingWithId('LOGOUT_ACK_FOR_PENDING_EVENTS_END');
              this.lockAction = false;
            },
          );
      });
  }

  getPerPieceTagHistorybyTagId(tagId: string) {
    return this.getSubjectKey().pipe(
      take(1),
      switchMap((subjectKey) => {
        return this.inputAppDataService.getPerPieceTagHistorybyTagId({ subjectKey: subjectKey, displayTagId: tagId });
      }),
    );
  }

  getSubjectKeyAndSelectedSubject() {
    return this.store.select(getSubjectKeyAndSelectedSubject);
  }

  getBundleTagHistorybyTagId(tagId: string) {
    return this.getSubjectKeyAndSelectedSubject().pipe(
      take(1),
      switchMap(({ subjectKey, selectedSubject }) => {
        return this.inputAppDataService.getBundleTagHistorybyTagId({
          subjectKey: subjectKey,
          domrole: selectedSubject?.gatek || '',
          subject: selectedSubject?.subject || '',
          bundleDisplayTagId: tagId,
        });
      }),
    );
  }

  getActionForUndoEvents(
    events: TBulkEventWithoutStatus[],
    eventAddtionMoreActions: TEventAddtionMoreActions,
    useRFIDScanMode: boolean,
  ) {
    if (useRFIDScanMode || eventAddtionMoreActions.syncDataWithBackend) {
      return new AcquireUserBgDBLockAndCheckEventsValidAndThenAddBulkEvents(events, eventAddtionMoreActions);
    } else {
      return new AcquireUserDBLockAndAddBulkEvents(events, false, eventAddtionMoreActions);
    }
  }

  getBCtxGroupedDetails(payload: TREQUEST_BctxGroupedDetails) {
    return this.inputAppDataService.getBCtxGroupedDetails(payload);
  }

  getBuyersAndStylesListFromOrdersForTechpackDropdowns() {
    return this.getSubjectKey().pipe(
      take(1),
      switchMap((subjectKey) => {
        return this.techpackUploadDataProvider.getFiltersDropdownData(subjectKey);
      }),
    );
  }

  fetchBuyersListBySelectedStyle(style: string) {
    return this.getSubjectKey().pipe(
      take(1),
      switchMap((subjectKey) => {
        return this.techpackUploadDataProvider.fetchBuyersListByStyle(subjectKey, style);
      }),
    );
  }

  fetchStylesListBySelectedBuyer(buyer: string) {
    return this.getSubjectKey().pipe(
      take(1),
      switchMap((subjectKey) => {
        return this.techpackUploadDataProvider.fetchStylesListByBuyer(subjectKey, buyer);
      }),
    );
  }

  fetchTechpackListingByBuyerAndStyleFilter(buyer: string, style: string) {
    return this.getSubjectKey().pipe(
      take(1),
      switchMap((subjectKey) => {
        return this.techpackUploadDataProvider.getTechpackUploadsListing({
          factoryId: subjectKey,
          pageNo: 1,
          pageSize: 10,
          filterMap: {
            buyer: [buyer],
            style: [style],
          },
        });
      }),
    );
  }

  viewTechpack(fileKeyOpt: string) {
    const URL = this.techpackUploadEnvProvider.getEnvVar('VIEW_TECHPACK') + `?key=${fileKeyOpt}`;
    return this.uploadDownloadFileService.downloadPdfFileForViewing(URL);
  }

  loadBctxPlanBased(chainActions: TLoadBctxSideActionsPlanBased) {
    this.store.dispatch(new AcquireUserDBLockAndSyncStyleInfoForPlanBased(chainActions));
  }

  AcquireUserDBLockAndPopulateLineMapForPlanBased(masterDataListMetaData: TMasterDataListMetaData) {
    this.store.dispatch(new AcquireUserDBLockAndPopulateLineMapForPlanBased(masterDataListMetaData));
  }

  getPlanBasedLineMap() {
    return this.store.select(getPlanBasedLineMap);
  }

  getLineMap() {
    return this.store.select(getLineMap);
  }

  getAllBctxItemsAcrossSelectedStaionId() {
    return this.store.select(getAllBctxItemsAcrossSelectedStaionId);
  }

  updateFilteredSizeListInLineMap(filteredSizesList: string[]) {
    this.store.dispatch(new AcquireLockAndUpdateFilteredSizesListInLineMap(filteredSizesList));
  }

  getFilteredSizesListForSelectedBctx() {
    return this.store.pipe(select(getFilteredSizesListForSelectedBctx));
  }

  getStore() {
    return this.store.select(getStore);
  }

  captureSnapShotsOfDbs(origin: string) {
    this.store.dispatch(new CaptureSnapShotOfDbs(origin));
  }

  getBulkMdPointEvents() {
    return this.store.pipe(select(getBulkMdPointEvents));
  }
}
